{
  "common": {
    "from": "{{price}} 起",
    "soon": "即将推出",
    "online": "线上",
    "back": "返回",
    "close": "关闭",
    "cancel": "取消",
    "apply": "应用",
    "retry": "重试",
    "retryLater": "请稍后再试。",
    "loading": "加载中…",
    "increase": "增加",
    "decrease": "减少"
  },
  "categories": {
    "HOME": {
      "name": "生活服务",
      "short": "保洁、维修、接送"
    },
    "DOCS": {
      "name": "证件办理",
      "short": "社保卡、翻译、居留"
    },
    "LEARNING": {
      "name": "学习与职业",
      "short": "语言课程与职业顾问"
    },
    "PERKS": {
      "name": "折扣与礼品",
      "short": "咖啡馆、餐厅、礼品"
    }
  },
  "services": {
    "cleaning": {
      "name": "保洁",
      "description": "日常、深度或装修后保洁。经过审核的保洁员，完成后提供照片报告。"
    },
    "repair": {
      "name": "维修",
      "description": "水管、电路和小修小补。师傅开工前先与您确认报价。"
    },
    "transfer": {
      "name": "接送机",
      "description": "机场接机或送您去赶航班。"
    },
    "social_card": {
      "name": "社保卡",
      "description": "协助办理社会保障卡。"
    },
    "passport_translation": {
      "name": "护照翻译",
      "description": "护照公证翻译。"
    },
    "residence_permit": {
      "name": "居留许可",
      "description": "全程协助办理居留许可。"
    },
    "lang_armenian": {
      "name": "亚美尼亚语",
      "description": "亚美尼亚语课程包，线上或线下。"
    },
    "lang_english": {
      "name": "英语",
      "description": "英语课程包，线上或线下。"
    },
    "career": {
      "name": "职业顾问",
      "description": "简历分析和求职计划。"
    }
  },
  "params": {
    "cleaning": {
      "cleaningType": {
        "label": "保洁类型",
        "regular": "日常",
        "regular_hint": "日常维护清洁",
        "general": "深度",
        "general_hint": "全面清洁，包括难以触及的地方",
        "renovation": "装修后",
        "renovation_hint": "灰尘、油漆和水泥痕迹"
      },
      "rooms": {
        "label": "房间数",
        "count_one": "{{count}} 个房间",
        "count_few": "{{count}} 个房间",
        "count_many": "{{count}} 个房间",
        "count_other": "{{count}} 个房间"
      },
      "bathrooms": {
        "label": "卫生间",
        "count_one": "{{count}} 个卫生间",
        "count_few": "{{count}} 个卫生间",
        "count_many": "{{count}} 个卫生间",
        "count_other": "{{count}} 个卫生间"
      }
    },
    "repair": {
      "repairType": {
        "label": "遇到什么问题",
        "plumbing": "水管",
        "plumbing_hint": "水龙头、管道、马桶",
        "electrical": "电路",
        "electrical_hint": "插座、灯具、线路",
        "minor": "小修小补",
        "minor_hint": "架子、门、家具"
      },
      "problem": {
        "label": "请描述问题"
      }
    },
    "transfer": {
      "direction": {
        "label": "方向",
        "fromAirport": "接机",
        "fromAirport_hint": "举牌接机",
        "toAirport": "送机",
        "toAirport_hint": "送您赶航班"
      },
      "flight": {
        "label": "航班号"
      },
      "passengers": {
        "label": "乘客人数"
      },
      "luggage": {
        "label": "行李件数"
      }
    },
    "social_card": {
      "forWhom": {
        "label": "为谁办理",
        "self": "本人",
        "self_hint": "一人",
        "family": "家人",
        "family_hint": "多人"
      }
    },
    "passport_translation": {
      "forWhom": {
        "label": "为谁办理",
        "self": "本人",
        "self_hint": "一本护照",
        "family": "家人",
        "family_hint": "多本护照"
      }
    },
    "residence_permit": {
      "forWhom": {
        "label": "为谁办理",
        "self": "本人",
        "self_hint": "一人",
        "family": "家人",
        "family_hint": "多人"
      }
    },
    "lang_armenian": {
      "level": {
        "label": "水平",
        "A1": "A1",
        "A1_hint": "零基础",
        "A2": "A2",
        "A2_hint": "初级",
        "B1": "B1",
        "B1_hint": "中级",
        "B2": "B2",
        "B2_hint": "中高级"
      },
      "format": {
        "label": "形式",
        "online": "线上",
        "online_hint": "视频授课",
        "offline": "线下",
        "offline_hint": "在埃里温"
      },
      "lessons": {
        "label": "课程包",
        "4": "4 节课",
        "4_hint": "体验",
        "8": "8 节课",
        "8_hint": "一个月",
        "12": "12 节课",
        "12_hint": "强化"
      }
    },
    "lang_english": {
      "level": {
        "label": "水平",
        "A1": "A1",
        "A1_hint": "零基础",
        "A2": "A2",
        "A2_hint": "初级",
        "B1": "B1",
        "B1_hint": "中级",
        "B2": "B2",
        "B2_hint": "中高级",
        "C1": "C1",
        "C1_hint": "高级"
      },
      "format": {
        "label": "形式",
        "online": "线上",
        "online_hint": "视频授课",
        "offline": "线下",
        "offline_hint": "在埃里温"
      },
      "lessons": {
        "label": "课程包",
        "4": "4 节课",
        "4_hint": "体验",
        "8": "8 节课",
        "8_hint": "一个月",
        "12": "12 节课",
        "12_hint": "强化"
      }
    },
    "career": {
      "topic": {
        "label": "主题",
        "resume": "简历分析",
        "resume_hint": "需要改进的地方",
        "jobSearch": "求职计划",
        "jobSearch_hint": "去哪里、怎样投递"
      }
    }
  },
  "extras": {
    "windows": {
      "name": "擦窗户",
      "per": "每扇"
    },
    "balconyGlazing": {
      "name": "阳台玻璃",
      "per": "每个阳台"
    },
    "balcony": {
      "name": "阳台清洁",
      "per": "每个阳台"
    },
    "fridge": {
      "name": "冰箱内部"
    },
    "oven": {
      "name": "烤箱内部"
    },
    "microwave": {
      "name": "微波炉内部"
    },
    "kitchenCabinets": {
      "name": "橱柜内部"
    },
    "complexKitchen": {
      "name": "重度油污厨房"
    },
    "chandelier": {
      "name": "吊灯",
      "per": "每盏"
    },
    "wardrobe": {
      "name": "衣帽间"
    },
    "limescale": {
      "name": "卫生间水垢和锈迹"
    },
    "petHair": {
      "name": "清除宠物毛发"
    },
    "litter": {
      "name": "宠物便盆",
      "per": "每个"
    },
    "ironing": {
      "name": "熨烫",
      "per": "每小时"
    },
    "extraTime": {
      "name": "额外时间",
      "per": "每 30 分钟"
    },
    "keys": {
      "name": "取送钥匙"
    },
    "experienced": {
      "name": "资深保洁员"
    },
    "vacuum": {
      "name": "自带吸尘器"
    }
  },
  "checklist": {
    "kitchen": "厨房",
    "bathroom": "卫生间",
    "rooms": "房间",
    "floors": "地面",
    "photoReport": "照片报告",
    "diagnostics": "检查",
    "estimate": "报价",
    "repair": "维修",
    "photo": "照片",
    "luggage": "行李",
    "address": "地址",
    "review": "复习",
    "newTopic": "新内容",
    "homework": "作业",
    "resume": "简历",
    "plan": "计划",
    "materials": "资料"
  },
  "status": {
    "CLEANING": {
      "NEW": "新订单",
      "ASSIGNED": "已指派",
      "EN_ROUTE": "在路上",
      "CLEANING": "保洁中",
      "DONE": "已完成",
      "CANCELLED": "已取消"
    },
    "REPAIR": {
      "NEW": "新订单",
      "ASSIGNED": "已指派",
      "ON_SITE": "已到达",
      "ESTIMATE_APPROVED": "报价已确认",
      "REPAIRING": "维修中",
      "DONE": "已完成",
      "CANCELLED": "已取消"
    },
    "TRANSFER": {
      "NEW": "新订单",
      "ASSIGNED": "已指派",
      "DRIVER_WAITING": "司机等候中",
      "RIDE_IN_PROGRESS": "行程中",
      "COMPLETED": "已完成",
      "CANCELLED": "已取消"
    },
    "LANGUAGE": {
      "ENROLLED": "已报名",
      "LESSON_SCHEDULED": "已排课",
      "LESSON_IN_PROGRESS": "上课中",
      "LESSON_DONE": "课程结束",
      "COMPLETED": "课程包已完成",
      "CANCELLED": "已取消"
    },
    "CAREER": {
      "NEW": "新订单",
      "CONSULTANT_ASSIGNED": "已指派顾问",
      "RESUME_RECEIVED": "已收到简历",
      "MEETING": "咨询中",
      "PLAN_SENT": "计划已发送",
      "CANCELLED": "已取消"
    },
    "DOCUMENTS": {
      "NEW": "新订单",
      "DOCS_REVIEW": "材料审核中",
      "NEEDS_MORE_DOCS": "需补充材料",
      "SUBMITTED": "已递交",
      "DONE": "已完成",
      "CANCELLED": "已取消"
    }
  },
  "payment": {
    "UNPAID": "未支付",
    "PAID": "已支付",
    "REFUNDED": "已退款"
  },
  "roles": {
    "CLEANER": "保洁员",
    "HANDYMAN": "维修师傅",
    "DRIVER": "司机",
    "TEACHER": "老师",
    "CAREER_CONSULTANT": "职业顾问",
    "DOCS_AGENT": "证件专员"
  },
  "districts": {
    "ajapnyak": "阿贾普尼亚克区",
    "arabkir": "阿拉布基尔区",
    "avan": "阿万区",
    "davtashen": "达夫塔申区",
    "erebuni": "埃里布尼区",
    "kanaker_zeytun": "卡纳克尔-泽伊通区",
    "kentron": "肯特龙区（市中心）",
    "malatia_sebastia": "马拉蒂亚-塞巴斯蒂亚区",
    "nork_marash": "诺尔克-马拉什区",
    "nor_nork": "新诺尔克区",
    "nubarashen": "努巴拉申区",
    "shengavit": "申加维特区"
  },
  "plans": {
    "free": {
      "perks": "合作伙伴折扣与礼品",
      "prices": "所有服务按原价",
      "status": "订单状态与聊天"
    },
    "plus": {
      "price": "{{price}}/月",
      "all": "包含 Barev 全部权益",
      "discount": "「{{category}}」享 −{{pct}}%"
    }
  },
  "errors": {
    "generic": "出了点问题，请重试。",
    "NOT_FOUND": "未找到该订单。",
    "FORBIDDEN": "无访问权限。",
    "CONSENT_REQUIRED": "请先同意个人数据处理。",
    "SERVICE_UNAVAILABLE": "该服务暂未开放。",
    "INVALID_PARAMS": "请检查订单信息。",
    "SLOT_UNAVAILABLE": "该时间已被预订，请选择其他时间。",
    "ADDRESS_REQUIRED": "请填写区域和地址。",
    "TRANSITION_NOT_ALLOWED": "当前无法执行此步骤，请刷新页面。",
    "CHECKLIST_INCOMPLETE": "请勾选清单中的所有项目。",
    "PHOTO_REQUIRED": "此项需要上传照片。",
    "ESTIMATE_NOT_ACCEPTED": "客户尚未确认报价。",
    "CANCEL_VIA_OPERATOR": "服务已开始，只能通过客服取消。",
    "RESCHEDULE_VIA_OPERATOR": "只能通过客服改期。",
    "AGENCY_CODE_INVALID": "该代码不存在，请核对租房合同中的代码。",
    "AGENCY_ALREADY_SET": "您已绑定其他房产中介。",
    "OFFER_NOT_ACTIVE": "该派单已失效。",
    "PROVIDER_BUSY": "该服务人员此时段已有安排。",
    "ALREADY_ASSIGNED": "订单已指派。",
    "INVITE_INVALID": "邀请链接无效，请向客服索取新链接。",
    "NOT_PAID_STATE": "该订单无法标记为已支付。",
    "BAD_CREDENTIALS": "登录名或密码错误。",
    "BAD_TOTP": "验证码错误，请检查手机时间。",
    "LOGIN_THROTTLED": "尝试次数过多，请等待 15 分钟。",
    "OWNER_ONLY": "仅限所有者。",
    "NOT_LINKED": "账号未绑定。",
    "NOT_PROVIDER": "仅限服务人员。",
    "CANNOT_DISABLE_SELF": "不能停用自己的账号。",
    "AGENCY_CODE_FORMAT": "代码只能包含拉丁字母和数字。",
    "TOTP_ALREADY_ENABLED": "双重验证已设置。",
    "ADMIN_LOGIN_REQUIRED": "请先登录。",
    "ADMIN_2FA_REQUIRED": "请用验证码确认登录。",
    "INIT_DATA_MISSING": "请通过 Telegram 打开应用。",
    "INIT_DATA_BAD_HASH": "请通过 Telegram 打开应用。",
    "INIT_DATA_EXPIRED": "会话已过期，请重新打开应用。",
    "BAD_FILE_TYPE": "请上传照片（JPG、PNG、WEBP）。",
    "NO_FILE": "未选择文件。",
    "UPLOAD": "照片上传失败。",
    "PHONE_INVALID": "请检查电话号码。",
    "REQUEST_THROTTLED": "提交次数过多，请 15 分钟后再试。",
    "CONTACT_INVALID": "请填写电话（+374…）或 Telegram 用户名（@username）。",
    "NAME_REQUIRED": "请告诉我们怎么称呼你。",
    "PROVIDER_NOT_LINKED": "服务人员尚未通过邀请打开工作机器人，暂时无法发送消息。",
    "CARD_EXPIRED": "二维码已过期或无效——请客户重新打开会员卡。",
    "OFFER_NOT_AVAILABLE": "该优惠不适用于客户当前等级。",
    "OFFER_LIMIT_REACHED": "该优惠次数已用完。",
    "CONCIERGE_SUBSCRIBERS_ONLY": "专属礼宾仅面向 Barev+ 和 Barev Elite 会员。目前请联系客服，我们同样会帮你。",
    "ASSIGNEE_NO_ACCESS": "该成员无权访问此频道。",
    "PROMO_INVALID": "优惠码不存在",
    "PROMO_EXPIRED": "优惠码已失效",
    "PROMO_USED": "该优惠码已使用",
    "PROMO_NOT_FOR_SERVICE": "该优惠码不适用于此服务",
    "POINTS_DUPLICATE_ORDER": "该订单已发放过 Bariki。",
    "POINTS_REASON_REQUIRED": "请填写原因。",
    "POINTS_BELOW_MIN": "金额低于最低限额。",
    "POINTS_NOT_ENOUGH": "Bariki 不足。",
    "POINTS_OVER_SHARE": "Bariki 只能支付订单的一部分。",
    "POINTS_OVER_LIMIT": "超出您的限额——需超级管理员批准。",
    "POINTS_FINAL": "该操作已无法撤销。",
    "POINTS_REQUEST_CLOSED": "该申请已处理或已过期。",
    "POINTS_TOO_MANY_REQUESTS": "您已有待处理的申请——请等待回复。",
    "POINTS_WITH_PROMO": "Bariki 不能与优惠码同时使用。",
    "PAYMENT_UNAVAILABLE": "暂时无法在线支付 — 请联系客服。",
    "PAYMENT_AMOUNT_OUT_OF_RANGE": "该金额无法在线支付 — 客服会协助你付款。",
    "ALREADY_SUBSCRIBED": "你已有自动续费的会员。",
    "PAYMENT_PROVIDER_ERROR": "支付服务无响应，请稍后再试。"
  },
  "client": {
    "nav": {
      "label": "导航",
      "home": "首页",
      "services": "服务",
      "newOrder": "新订单",
      "perks": "折扣",
      "profile": "我的",
      "plan": "计划",
      "docs": "证件",
      "orders": "订单",
      "card": "会员卡",
      "chat": "聊天"
    },
    "openInTelegram": {
      "title": "请在 Telegram 中打开",
      "text": "Barev Club 在 Telegram 内运行。请在我们的机器人中点击「打开应用」。"
    },
    "consent": {
      "title": "马上就好",
      "text": "下单前需要您同意我们处理个人数据：姓名、地址和订单信息。这些信息会提供给为您服务的人员和政策中列出的合作方，并存储在德国的服务器上。",
      "policyLink": "隐私政策",
      "accept": "同意并继续",
      "giftToast": "房产中介赠送的礼品已激活"
    },
    "home": {
      "hello": "Barev，你好！",
      "guest": "朋友",
      "myOrders": "我的订单",
      "allOrders": "全部",
      "noOrders": "还没有订单。预订第一个服务只需 2 分钟。",
      "repeatLast": "再来一单",
      "enterCode": "房产中介代码",
      "plusUntil": "Barev+ 有效期至 {{date}}",
      "discount": "Barev+ 享 −{{pct}}%",
      "upsellTitle": "Barev Elite 最高 −{{pct}}%",
      "upsellText": "保洁、维修、接送、证件和合作伙伴礼品",
      "levelUntil": "{{plan}} 有效期至 {{date}}",
      "now": "进行中",
      "moreActive": "其他进行中：{{count}}",
      "orderTitle": "预订服务",
      "cardShow": "出示二维码",
      "free": "免费等级",
      "chatTitle": "有任何问题，请在聊天中提问",
      "chatText": "我们用您的语言回复"
    },
    "services": {
      "title": "服务",
      "plusDiscount": "您的 Barev+ 折扣：−{{pct}}%",
      "callback": "提交申请",
      "yourDiscount": "你的折扣 −{{pct}}%",
      "withElite": "Barev Elite 享 −{{pct}}%"
    },
    "order": {
      "unavailable": "该服务即将上线。",
      "duration": "约 {{hours}} 小时",
      "when": "时间",
      "date": "日期",
      "noSlots": "当天没有空闲时段，请选择其他日期。",
      "pickSlot": "请选择时间。",
      "address": "地址",
      "district": "区域",
      "districtPlaceholder": "选择区域",
      "pickDistrict": "请选择区域。",
      "addressLabel": "街道、楼号、门牌号",
      "addressPlaceholder": "普希金街 10 号 15 室",
      "enterAddress": "请填写地址。",
      "note": "给服务人员的备注",
      "notePlaceholder": "门禁、楼层、宠物…",
      "payment": "支付方式",
      "paymentHint": "服务完成后支付。在线支付稍后上线。",
      "price": "费用",
      "discount": "Barev+ 折扣 −{{pct}}%",
      "plusHint": "开通 Barev+ 可便宜 {{pct}}%",
      "total": "合计",
      "confirm": "确认下单",
      "cancelPolicy": "开始前 {{hours}} 小时以上可免费取消或改期，之后取消将扣除 {{pct}}%。",
      "created": "订单 #{{number}} 已创建",
      "extras": "附加服务",
      "add": "添加",
      "promo": "优惠码",
      "promoPlaceholder": "如有优惠码请输入",
      "promoApply": "使用",
      "promoRemove": "移除",
      "promoLine": "优惠码 {{code}} −{{pct}}%",
      "promoWeaker": "会员折扣更大，将使用会员折扣"
    },
    "orders": {
      "title": "我的订单",
      "active": "进行中",
      "history": "历史",
      "noHistory": "已完成的订单会显示在这里。",
      "order": "预订服务"
    },
    "detail": {
      "progress": "状态",
      "arrived": "已到达",
      "photoReport": "照片报告",
      "cancelFee": "取消扣款",
      "reschedule": "改期",
      "rescheduleConfirm": "改到这个时间",
      "rescheduled": "订单已改期",
      "cancel": "取消订单",
      "confirmCancelFree": "确定取消订单吗？本次取消免费。",
      "confirmCancelLate": "距离开始不足一天，将扣除 {{fee}}（{{pct}}%）。确定取消吗？",
      "cancelled": "订单已取消",
      "cancelledWithFee": "订单已取消。扣款：{{fee}}",
      "viaOperator": "距离开始不足 {{hours}} 小时，只能通过客服取消或改期——请给机器人发消息。",
      "repeat": "再来一单",
      "orderAgain": "重新下单",
      "providerLabel": {
        "CLEANING": "保洁员",
        "REPAIR": "维修师傅",
        "TRANSFER": "司机",
        "LANGUAGE": "老师",
        "CAREER": "顾问",
        "DOCUMENTS": "专员"
      },
      "when": "时间",
      "where": "地点",
      "who": "服务人员",
      "whoPending": "正在分配",
      "payment": "付款",
      "ask": "关于此订单的问题",
      "payOnline": "在线支付 · {{price}}",
      "payOnlineHint": "通过 Tribute 刷卡，按汇率以欧元支付：{{amd}} ≈ {{rub}}",
      "payAwaiting": "正在等待付款确认…",
      "paidOnline": "付款成功，谢谢！"
    },
    "perks": {
      "title": "折扣",
      "soonTitle": "合作伙伴即将上线",
      "soonText": "咖啡馆、餐厅和合作伙伴礼品将在这里展示。结账时出示会员卡即可。"
    },
    "profile": {
      "title": "我的",
      "fromAgency": "房产中介 {{agency}} 的客户",
      "noAgency": "未绑定房产中介",
      "membership": "Barev / Barev+ 会员",
      "codeTitle": "房产中介代码",
      "codeText": "通过合作房产中介租房？输入合同上的代码，即可领取中介赠送的礼品。",
      "codePlaceholder": "例如 DOMIK",
      "codeAccepted": "代码已生效：{{agency}}",
      "codeGift": "代码已生效：{{agency}}。礼品已激活！",
      "language": "语言"
    },
    "membership": {
      "title": "会员",
      "current": "当前方案",
      "howToGet": "使用房产中介代码可免费获得 Barev+。在线订阅即将上线。",
      "request": "订阅 {{plan}}",
      "requested": "申请已发送，客服会联系你",
      "requestHint": "客服会在 Telegram 联系你，商定付款并开通订阅。",
      "pendingTitle": "申请已发送",
      "pendingText": "客服很快会联系你开通订阅。",
      "approx": "≈ {{amd}} · ≈ {{rub}} — 以欧元支付",
      "pay": "开通 {{plan}}，{{price}}/月",
      "payRenew": "开启自动续费 · {{price}}/月",
      "payHint": "通过 Tribute 刷卡支付。每月自动续费，可随时在此关闭。",
      "payOther": "其他方式支付 — 联系客服",
      "renewOn": "已开启自动续费",
      "nextCharge": "下次扣款：{{date}} — {{price}}",
      "renewOffButton": "关闭自动续费",
      "renewOffConfirm": "关闭自动续费？会员资格将保留到已付月份结束。",
      "renewOff": "已关闭自动续费",
      "switchHint": "你已开通带自动续费的 {{plan}}。如需更换套餐，请先关闭其自动续费。",
      "awaitingTitle": "正在等待付款确认",
      "awaitingText": "通常只需几秒钟，会员将自动开通。",
      "paid": "付款成功 — 会员已开通"
    },
    "segment": {
      "title": "你好！介绍一下你自己",
      "sub": "我们会展示你需要的内容。可在个人资料中更改。",
      "moving": "我要搬来",
      "movingText": "分步搬家计划、证件清单和礼宾服务",
      "living": "我已住在亚美尼亚",
      "livingText": "折扣服务、俱乐部合作伙伴和订单",
      "profileTitle": "我的场景"
    },
    "move": {
      "title": "我的搬家",
      "daysLeft_one": "还有 {{count}} 天",
      "daysLeft_few": "还有 {{count}} 天",
      "daysLeft_many": "还有 {{count}} 天",
      "daysLeft_other": "还有 {{count}} 天",
      "progress": "已完成 {{done}}/{{total}} 步",
      "noSteps": "客服会联系你并制定计划，步骤会显示在这里。",
      "afterTitle": "已经搬来了？",
      "afterText": "在个人资料中切换为“我已住在亚美尼亚”，查看折扣服务和俱乐部合作伙伴。",
      "formHello": "{{name}}，我们开始吧",
      "formTitle": "一起规划你的搬家",
      "formSub": "回答几个问题，客服会制定计划并报价。",
      "whenTitle": "什么时候搬？",
      "packageTitle": "需要什么？",
      "customTitle": "选择需要的服务",
      "errPackage": "请选择套餐。",
      "errWhen": "请选择一个选项或填写日期。",
      "errEmpty": "请至少选择一项服务。",
      "comment": "备注",
      "commentHint": "几个人、是否有孩子或宠物、有什么特别要求",
      "submit": "提交计划",
      "created": "计划已提交，客服很快会联系你",
      "status": {
        "TODO": "待办",
        "IN_PROGRESS": "进行中",
        "DONE": "已完成",
        "SKIPPED": "不需要"
      }
    },
    "docs": {
      "title": "证件",
      "sub": "搬家前需要准备的材料。勾选后就不会遗漏。",
      "progress": "已准备 {{done}}/{{total}}",
      "needPlan": "请先制定搬家计划，再勾选证件。",
      "ask": "咨询礼宾"
    },
    "concierge": {
      "title": "礼宾",
      "short": "在聊天中留言，我们会在那里回复"
    },
    "request": {
      "title": "提交申请",
      "sub": "客服会联系你，确认细节并下单。",
      "comment": "需要做什么",
      "commentHint": "例如：厨房水龙头漏水，18:00 以后方便",
      "submit": "提交申请",
      "sentTitle": "第 {{number}} 号申请已发送",
      "sentText": "客服会在工作时间联系你。",
      "back": "返回服务",
      "yourDiscount": "订阅折扣 −{{pct}}%"
    },
    "partners": {
      "howTo": "结账时出示二维码，店员用相机扫描。二维码每分钟更新，截图无效。",
      "cat": {
        "cafe": "咖啡馆",
        "restaurant": "餐厅",
        "shop": "商店",
        "beauty": "美容",
        "other": "其他"
      },
      "qrLabel": "会员卡二维码",
      "qrRefresh": "{{seconds}} 秒后刷新",
      "allMembers": "所有会员",
      "needLevel": "{{level}} 专享",
      "limit_ONCE": "首次到店",
      "limit_WEEK": "每周 {{count}} 次",
      "limit_MONTH": "每月 {{count}} 次",
      "used_ONCE": "已使用",
      "used_WEEK": "下周可再次使用",
      "used_MONTH": "下月可再次使用"
    },
    "chat": {
      "title": "与 Barev Club 聊天",
      "support": "客服",
      "concierge": "专属礼宾",
      "hint": "这与机器人聊天是同一个对话：回复会同时出现在这里和 Telegram。",
      "empty": "告诉我们需要什么帮助，我们会在这里回复。",
      "placeholder": "输入消息…",
      "send": "发送",
      "attach": "附加照片或文件",
      "conciergeOnly": "专属礼宾包含在 Barev+ 和 Barev Elite 中",
      "team": "Barev Club",
      "fileTooBig": "文件超过 10 MB",
      "file": "文件"
    },
    "rate": {
      "title": "服务体验如何？",
      "text": "您的评价帮助我们保证服务质量",
      "comment": "评论（可选）",
      "send": "提交评价",
      "thanks": "感谢您的评价！",
      "yours": "您的评价",
      "change": "修改",
      "star": "{{count}} / 5",
      "prompt": "请评价订单"
    },
    "card": {
      "title": "俱乐部会员卡",
      "partners": "俱乐部合作伙伴",
      "plans": "等级与折扣"
    },
    "points": {
      "title": "Bariki",
      "balance": "可用",
      "equals": "Bariki ≈ {{amount}} ֏ · 1 Bariki = 1 ֏",
      "pending": "待生效：{{amount}}，{{date}} 起可用",
      "burn": "{{amount}} 将于 {{date}} 过期——任意订单即可保留",
      "pay": "用 Bariki 支付",
      "enterCode": "输入代码",
      "requestPending": "您的 Bariki 支付申请正在等待确认。",
      "rates": "各类别返现",
      "plusWouldGet": "若是 Barev+，过去 30 天可多得 +{{amount}} Bariki →",
      "streak": "连续保洁",
      "streakLeft": "再 {{left}} 次，保洁返现 +{{bonus}}%。两次间隔不超过 {{days}} 天。",
      "streakMax": "最高连续：每次保洁返现 +{{bonus}}%。",
      "route": "首月路线",
      "routeText": "在 {{date}} 前预订 3 个不同类别的服务，即得 {{amount}} Bariki。当前：{{done}}/3。",
      "history": "记录",
      "empty": "每笔已付款订单都可获得 Bariki——按您等级的比例返现。",
      "availableFrom": "{{date}} 起可用",
      "until": "至 {{date}}",
      "payHint": "Bariki 最多可支付订单的 {{pct}}%，最低 {{min}}。团队确认后会告知需补付金额。",
      "forOrder": "订单",
      "otherOrder": "其他订单（不在应用内）",
      "amount": "使用多少 Bariki",
      "max": "最多：{{max}}",
      "note": "备注",
      "notePh": "哪个订单、金额多少",
      "send": "发送申请",
      "requested": "申请已发送——我们会在聊天中回复。",
      "useInOrder": "使用 {{amount}} Bariki",
      "useHint": "最多订单的 {{pct}}% · 余额 {{balance}}",
      "notWithPromo": "不能与优惠码同时使用",
      "belowMin": "最低 {{min}} · 余额 {{balance}}",
      "paidLine": "Bariki 支付",
      "type": {
        "accrual": "返现",
        "bonus": "奖励",
        "redemption": "Bariki 支付",
        "request": "支付申请",
        "reversal": "撤销"
      },
      "status": {
        "PENDING": "待生效",
        "ACTIVE": "可用",
        "SPENT": "已用完",
        "EXPIRED": "已过期",
        "REVERSED": "已撤销",
        "REQUESTED": "等待确认",
        "CONFIRMED": "已扣除",
        "REJECTED": "已拒绝",
        "ACCRUAL": "发放已撤销",
        "REDEMPTION": "Bariki 已退回"
      }
    }
  },
  "pro": {
    "nav": {
      "label": "导航",
      "today": "今天",
      "history": "历史",
      "company": "公司",
      "partner": "合作伙伴"
    },
    "openInTelegram": {
      "title": "请在 Telegram 中打开",
      "text": "服务人员工作台需从 Barev Pro 机器人打开。"
    },
    "notLinked": {
      "title": "账号未绑定",
      "text": "请向客服索取邀请链接，并在 Telegram 中打开。"
    },
    "today": {
      "onShift": "上班中",
      "offShift": "未上班",
      "earned": "收入",
      "orders": "订单",
      "rating": "评分",
      "now": "当前",
      "open": "打开订单",
      "title": "今日订单",
      "empty": "今天没有订单。",
      "upcoming": "接下来"
    },
    "offer": {
      "title": "新订单",
      "accept": "接单",
      "decline": "拒绝",
      "accepted": "已接单",
      "declined": "您已拒绝该订单",
      "left": "剩余"
    },
    "action": {
      "depart": "已出发",
      "arrived": "我已到达",
      "startCleaning": "开始保洁",
      "finishCleaning": "完成并发送照片",
      "startWork": "开始工作",
      "closeRepair": "结束订单",
      "atPickup": "我在机场",
      "passengerIn": "乘客已上车",
      "finishRide": "结束行程",
      "scheduleLesson": "安排课程",
      "openLesson": "打开课程",
      "startLesson": "开始",
      "finishLesson": "结束课程",
      "openMeeting": "打开咨询",
      "startMeeting": "开始",
      "finishMeeting": "结束"
    },
    "job": {
      "when": "时间",
      "where": "地点",
      "client": "客户",
      "clientLanguage": "语言",
      "price": "金额",
      "checklist": "清单",
      "checklistFirst": "完成前请勾选所有清单项目并上传照片。",
      "takePhoto": "拍照",
      "retakePhoto": "重拍",
      "confirmFinish": "确定完成订单吗？客户将收到通知和照片报告。",
      "markPaid": "客户已付款",
      "confirmPaid": "确认客户已支付 {{amount}}？",
      "paidMarked": "已记录付款"
    },
    "history": {
      "title": "历史",
      "week": "近 7 天",
      "month": "本月",
      "prevMonth": "上月",
      "earned": "收入",
      "done": "已完成",
      "empty": "该时段没有订单。",
      "ratePercent": "费率：订单金额的 {{value}}%",
      "rateFixed": "费率：每单 {{value}}",
      "ratePreset": "费率：「{{name}}」方案",
      "ratePartner": "订单报酬由您的公司决定"
    },
    "company": {
      "title": "公司",
      "pending": "待分配",
      "noPending": "所有订单都已分配。",
      "assign": "分配员工",
      "chooseStaff": "交给谁",
      "assigned": "已分配",
      "noAssigned": "暂无。",
      "assigned_ok": "已分配员工",
      "staff": "员工",
      "notLinked": "未加入机器人",
      "free": "空闲",
      "busy": "忙碌",
      "speaksLanguage": "会客户的语言",
      "load_one": "当天 {{count}} 单",
      "load_few": "当天 {{count}} 单",
      "load_many": "当天 {{count}} 单",
      "load_other": "当天 {{count}} 单"
    },
    "partner": {
      "owner": "所有者",
      "staff": "员工",
      "visits30_one": "30 天内核验 {{count}} 次",
      "visits30_few": "30 天内核验 {{count}} 次",
      "visits30_many": "30 天内核验 {{count}} 次",
      "visits30_other": "30 天内核验 {{count}} 次",
      "scan": "扫描客户二维码",
      "scanSub": "显示客户等级和可享优惠",
      "scanHint": "将相机对准客户应用中的二维码",
      "noScanner": "扫描仅在 Telegram 内可用，也可手动输入代码。",
      "manual": "或粘贴二维码中的代码/链接",
      "check": "核验",
      "valid": "{{name}} — {{level}}",
      "until": "订阅至 {{date}}",
      "needLevel": "需要 {{level}}",
      "unlimited": "不限次数",
      "redeemed": "已核销：{{offer}}",
      "offers": "您的俱乐部优惠",
      "noOffers": "暂无优惠。",
      "offersHint": "如需修改优惠，请联系俱乐部客服。",
      "allMembers": "所有会员",
      "limit_ONCE": "仅首次到店",
      "limit_WEEK": "每周 {{count}} 次",
      "limit_MONTH": "每月 {{count}} 次",
      "team": "员工",
      "invite": "邀请",
      "inviteQr": "员工邀请二维码",
      "inviteHint": "员工用手机相机扫描此二维码并点击 Start。一次性，有效期至 {{time}}。",
      "inviteLink": "或发送链接",
      "remove": "移除",
      "removeConfirm": "将 {{name}} 移出员工？",
      "recent": "最近核验",
      "noRecent": "暂无核验。",
      "checked": "核验会员卡"
    },
    "web": {
      "loginHint": "打开工作机器人，点击「在电脑上打开」（或发送 /web），即可收到登录链接。"
    },
    "cab": {
      "tab": {
        "orders": "订单",
        "staff": "员工",
        "money": "收入",
        "settings": "设置"
      },
      "autoOn": "自动分配已开启：新订单会自动派给空闲员工。",
      "income": "您的收入",
      "deadline": "请在 {{time}} 前指派",
      "offeredTo": "等待 {{name}} 回复",
      "decline": "拒绝",
      "declineConfirm": "拒绝此订单？订单将退回 Barev Club。",
      "declined": "订单已退回",
      "reassign": "重新指派",
      "unassignConfirm": "将 {{name}} 从订单中移除？订单将重新等待指派。",
      "unassigned": "已移除该员工",
      "gapHint": "订单之间的路程间隔：{{min}} 分钟。",
      "noStaff": "还没有员工——请在「员工」中添加。",
      "dayLoad": "当天 {{n}}/{{max}}",
      "weekLoad": "本周 {{n}}",
      "district": "同区",
      "check": {
        "ok": "空闲",
        "busy": "忙碌",
        "gap": "来不及赶到",
        "limit": "已达每日上限",
        "notLinked": "未登录机器人",
        "gap_confirm": "两单之间的路程时间少于设定值。仍要指派吗？",
        "limit_confirm": "该员工当天已达订单或工时上限。仍要指派吗？",
        "notLinked_confirm": "该员工尚未登录工作机器人，将收不到通知。仍要指派吗？",
        "busy_confirm": "该员工此时忙碌。"
      },
      "addStaff": "添加员工",
      "todayLoad": "今天 {{n}}/{{max}}",
      "hoursMax": "每天最多 {{n}} 小时",
      "off": "已停用",
      "staffAdded": "员工已添加",
      "saved": "已保存",
      "inviteText": "把此链接发给员工：打开工作机器人后即可接单。",
      "done": "完成",
      "f": {
        "name": "姓名",
        "phone": "电话",
        "languages": "语言",
        "districts": "区域（留空表示不限）",
        "days": "工作日",
        "from": "从",
        "to": "到",
        "maxOrders": "每天最多订单",
        "maxHours": "每天最多小时",
        "loadHint": "留空表示不限。自动分配不会超出上限。"
      },
      "save": "保存",
      "resetInvite": "新的登录链接",
      "resetConfirm": "生成新链接？员工当前的机器人登录将失效。",
      "turnOff": "停用",
      "turnOn": "启用",
      "offConfirm": "停用 {{name}}？其将不再收到新订单。",
      "copy": "复制",
      "copied": "已复制",
      "balance": "待支付",
      "accrued": "已计入",
      "paidOut": "已支付",
      "terms": {
        "COMMISSION": "条款：Barev Club 收取已付订单的 {{pct}}%，其余归您。工资和费用由您承担。",
        "PROFIT_SHARE": "条款：保洁员工资（{{fot}}%）和税费（{{tax}}%）由 Barev Club 支付，您获得剩余部分的 {{pct}}%。"
      },
      "byMonth": "按月",
      "ordersN": "订单：{{n}}",
      "byOrder": "按订单",
      "noIncome": "客户为已完成订单付款后，收入将显示在这里。",
      "paidBy": "已付 {{sum}}",
      "minus": "−工资 {{fot}}，−税费 {{tax}}，您的 {{pct}}%",
      "minusCommission": "−{{pct}}% Barev Club",
      "payouts": "付款记录",
      "payout": {
        "paid": "已支付",
        "pending": "待支付"
      },
      "auto": "自动分配",
      "autoHint": "新订单会派给最合适的空闲员工：排班空闲、来得及赶到、未超上限；优先考虑会说客户语言、在该区工作、本周订单较少、评分较高的员工。拒绝或未回复则派给下一位。",
      "gap": "订单之间的路程间隔，分钟",
      "gapMin": "不少于 {{min}} 分钟",
      "timeoutHint": "如 {{min}} 分钟内未指派，订单将退回 Barev Club。",
      "managers": "管理员",
      "you": "您",
      "remove": "移除",
      "removeManagerConfirm": "将 {{name}} 从管理员中移除？",
      "managerInvite": "邀请其他管理员的链接——打开工作机器人即可访问后台：",
      "logout": "在此电脑上退出",
      "wd": {
        "0": "周一",
        "1": "周二",
        "2": "周三",
        "3": "周四",
        "4": "周五",
        "5": "周六",
        "6": "周日"
      }
    }
  },
  "bot": {
    "client": {
      "chooseLanguage": "Выбери язык · Choose your language · 选择语言 · Ընտրեք լեզուն · Elige tu idioma",
      "languageSet": "语言：{{language}}",
      "fromAgency": "您好！您来自房产中介 {{agency}}——我们为您准备了礼品。",
      "consentText": "使用 Barev Club 需要您同意个人数据处理。数据会提供给为您服务的人员和政策中列出的合作方，并存储在德国的服务器上。\n\n<a href=\"{{url}}\">隐私政策</a>",
      "consentAccept": "同意",
      "giftActivated": "🎁 来自房产中介的礼品：{{plan}} 有效期至 {{date}}。服务折扣已生效。",
      "welcome": "在埃里温，从第一天起就像在家。\n\n预订保洁等服务、跟踪订单状态、享受合作伙伴折扣——尽在应用中。",
      "openApp": "打开应用",
      "enterCode": "输入房产中介代码",
      "changeLanguage": "切换语言",
      "codePrompt": "请发送租房合同上的房产中介代码。",
      "codeAccepted": "代码已生效：{{agency}}。",
      "help": "点击「打开应用」预订服务。命令：/app — 应用，/code — 房产中介代码，/language — 语言。",
      "cmdStart": "开始",
      "cmdApp": "打开应用",
      "cmdCode": "输入房产中介代码",
      "cmdLanguage": "切换语言",
      "cmdHelp": "帮助",
      "webRequestOrdered": "申请 {{request}} 号已收到，并已生成订单 {{order}} 号，时间：{{date}}。状态请在应用中查看。",
      "webRequestLinked": "申请 {{request}} 号已收到。客服会联系你确认时间。",
      "conciergeReceived": "已转给礼宾，我们会在这个聊天中回复你。",
      "supportReceived": "已转给客服，我们会在这个聊天中回复你。",
      "channelSupport": "现在你在给客服写信。直接发送消息、照片或文件即可。",
      "channelConcierge": "现在你在给专属礼宾写信。直接发送消息、照片或文件即可。",
      "cmdSupport": "联系客服",
      "cmdConcierge": "联系礼宾（Barev+）",
      "rated": "感谢您的评价！{{stars}}",
      "ratedLow": "很抱歉服务不够好。请在这里告诉我们发生了什么，团队会处理。",
      "wr": {
        "intro": "已收到您的申请 №{{request}}。再回答几个问题即可下单。",
        "askDistrict": "房子在哪个区？",
        "askAddress": "请发送地址：街道、楼号、门牌号。",
        "askDay": "什么时候方便？请选择日期。",
        "askTime": "请选择 {{day}} 的时间：",
        "dayFull": "这一天已约满，请选择其他日期。",
        "noSlots": "近几天没有空闲时间——客服会联系您安排时间。"
      },
      "cmdBalance": "Bariki 余额",
      "cmdHistory": "Bariki 记录",
      "points": {
        "balance": "🪙 Bariki：{{balance}}（≈ {{balance}} ֏）",
        "pending": "⏳ 待生效：{{pending}}，{{date}} 起可用",
        "burn": "🔥 若无订单，将于 {{date}} 过期",
        "empty": "暂无 Bariki 记录。",
        "open": "打开 Bariki",
        "type": {
          "accrual": "返现",
          "bonus": "奖励",
          "redemption": "Bariki 支付",
          "request": "支付申请",
          "reversal": "撤销"
        },
        "status": {
          "PENDING": "待生效",
          "ACTIVE": "可用",
          "SPENT": "已用完",
          "EXPIRED": "已过期",
          "REVERSED": "已撤销",
          "REQUESTED": "等待确认",
          "CONFIRMED": "已扣除",
          "REJECTED": "已拒绝",
          "ACCRUAL": "发放已撤销",
          "REDEMPTION": "Bariki 已退回"
        }
      }
    },
    "pro": {
      "notLinked": "此机器人供 Barev Club 服务人员使用。请向客服索取邀请链接。",
      "linkedProvider": "完成，{{name}}！账号已绑定。",
      "linkedDispatcher": "完成！您是「{{name}}」的调度员。",
      "youAreProvider": "{{name}} · {{role}}",
      "youAreDispatcher": "「{{company}}」调度员",
      "welcome": "新订单会发到这里。用消息中的按钮接单，并在工作台管理当天订单。",
      "openCabinet": "打开工作台",
      "messageReceived": "已转给客服，回复会发到这里。",
      "openWeb": "💻 在电脑上打开",
      "webLink": "浏览器后台链接（一次性，15 分钟内有效）：\n{{url}}"
    },
    "admin": {
      "hello": "{{name}}，Barev Club 后台通知会发到这里。",
      "linked": "完成，{{name}}！后台通知会发到这里。点“回复”即可回复客户。",
      "linkInvalid": "链接已失效——请在后台再次点击“连接 Telegram”。",
      "notAdmin": "此 Telegram 未连接后台。",
      "open": "在后台打开",
      "reply": "回复",
      "replyPrompt": "回复 {{name}}——直接输入消息。/cancel 取消。",
      "replyPlaceholder": "回复内容",
      "replySent": "已发送：{{name}}",
      "replyCancelled": "已取消回复。",
      "provider": "服务人员",
      "newOrder": "新订单 #{{number}}",
      "newLead": "搬家申请 #{{number}}",
      "newRequest": "应用申请 #{{number}}",
      "newWebRequest": "网站申请 #{{number}}",
      "loginOk": "登录已确认，请返回浏览器。",
      "loginExpired": "登录链接已过期，请刷新管理页面。",
      "channelSupport": "客服",
      "channelConcierge": "礼宾",
      "file": "文件",
      "chatAssigned": "{{by}} 将对话转交给你：{{name}}",
      "order": "订单 #{{number}}",
      "noOrder": "当前没有订单",
      "autoFailed": "订单 #{{number}} 没有找到空闲的服务人员，请手动分配。",
      "partnerDeclined": "合作方「{{partner}}」拒绝了订单 №{{number}}——请重新指派",
      "partnerExpired": "合作方「{{partner}}」未及时为订单 №{{number}} 指派员工——请重新指派",
      "noTime": "未指定时间",
      "noAddress": "未指定地址",
      "points": {
        "forOrder": "Order #{{number}} for {{sum}}",
        "confirm": "✅ Confirm",
        "reject": "Decline",
        "request": "Client asks to pay with bariki: {{amount}}",
        "balance": "balance {{balance}}",
        "suggestions": "New bariki suggestions: {{count}} ({{open}} in the queue)",
        "overLimit": "{{by}} wants to process {{amount}} bariki — above the limit, needs your approval",
        "mismatch": "Bariki reconciliation: {{count}} clients had a mismatched balance — fixed, check the log",
        "confirmed": "Redeemed {{amount}} bariki",
        "rejected": "Request declined",
        "help": "Credit for an order: /barik <phone or @username> <order amount> [category]\nCategories: cleaning, documents, learning, repair, transfer",
        "noClient": "Client not found",
        "preview": "Credit {{amount}} bariki to {{name}} for {{what}} {{sum}} ֏ ({{tier}}, {{rate}}%). Available from {{date}}.",
        "accrue": "🪙 Credit",
        "done": "Credited {{amount}} bariki",
        "needsApproval": "Above the limit — sent to a super admin for approval",
        "zero": "The amount is 0 — nothing to credit"
      },
      "pay": {
        "subscription": "{{plan}} 会员",
        "order": "订单 #{{number}} · {{service}}",
        "paid": "在线付款",
        "renewed": "会员续费",
        "refunded": "在线付款已退款",
        "cancelled": "自动续费已停止",
        "attention": "付款需要处理",
        "attentionHint": "客户已在线付款，但订单已付款或已取消 — 需在 Tribute 退款。",
        "fromSite": "网站付款（尚未绑定 Telegram）"
      }
    },
    "partner": {
      "valid": "{{name}} — {{level}}，会员卡有效",
      "until": "订阅至 {{date}}",
      "needLevel": "需要 {{level}}",
      "noOffers": "暂无优惠——请联系俱乐部客服。",
      "notPartner": "这是 Barev Club 会员卡，仅俱乐部合作伙伴可以核验。",
      "redeem": "核销",
      "redeemed": "已核销",
      "redeemedText": "已核销：{{offer}}",
      "linkedOwner": "完成！您是“{{partner}}”的所有者。打开后台：优惠、员工和二维码扫描。",
      "linkedStaff": "完成！您是“{{partner}}”的员工。用相机或在后台扫描客户二维码。",
      "youAreOwner": "“{{partner}}”所有者",
      "youAreStaff": "“{{partner}}”员工",
      "left_ONCE": "首次到店",
      "left_WEEK": "本周剩余：{{count}}",
      "left_MONTH": "本月剩余：{{count}}",
      "used_ONCE": "已使用",
      "used_WEEK": "本周已使用",
      "used_MONTH": "本月已使用"
    }
  },
  "notify": {
    "openOrder": "打开订单",
    "duration": "{{minutes}} 分钟",
    "clientLanguage": "客户语言",
    "created": "订单已受理：{{when}}。合计 {{total}}。指派服务人员后会通知您。",
    "rescheduled": "订单已改到 {{when}}。",
    "reminder24": "提醒：明天 {{when}}。",
    "reminder1": "一小时后：{{when}}。",
    "event": {
      "arrived": "服务人员已到达。",
      "openLesson": "课程即将开始。",
      "openMeeting": "咨询即将开始。"
    },
    "status": {
      "CLEANING": {
        "NEW": "正在为 {{when}} 重新寻找保洁员。",
        "ASSIGNED": "保洁员 {{provider}} 已指派，时间 {{when}}。",
        "EN_ROUTE": "保洁员 {{provider}} 正在路上。",
        "CLEANING": "保洁已开始。",
        "DONE": "保洁已完成。照片报告在应用中查看。",
        "CANCELLED": "订单已取消。"
      },
      "REPAIR": {
        "NEW": "正在为 {{when}} 寻找维修师傅。",
        "ASSIGNED": "维修师傅 {{provider}} 已指派，时间 {{when}}。",
        "ON_SITE": "师傅已到达，正在准备报价。",
        "ESTIMATE_APPROVED": "报价已确认。",
        "REPAIRING": "维修已开始。",
        "DONE": "维修已完成。",
        "CANCELLED": "订单已取消。"
      },
      "TRANSFER": {
        "NEW": "正在为 {{when}} 寻找司机。",
        "ASSIGNED": "司机 {{provider}} 已指派，时间 {{when}}。",
        "DRIVER_WAITING": "司机正在等您。",
        "RIDE_IN_PROGRESS": "行程已开始。",
        "COMPLETED": "行程已结束。",
        "CANCELLED": "订单已取消。"
      },
      "LANGUAGE": {
        "ENROLLED": "您已报名课程。",
        "LESSON_SCHEDULED": "已排课：{{when}}。",
        "LESSON_IN_PROGRESS": "课程已开始。",
        "LESSON_DONE": "课程已结束。",
        "COMPLETED": "课程包已全部完成！",
        "CANCELLED": "订单已取消。"
      },
      "CAREER": {
        "NEW": "正在为您寻找顾问。",
        "CONSULTANT_ASSIGNED": "顾问 {{provider}} 已指派。",
        "RESUME_RECEIVED": "已收到简历。",
        "MEETING": "咨询已开始。",
        "PLAN_SENT": "您的求职计划已准备好。",
        "CANCELLED": "订单已取消。"
      },
      "DOCUMENTS": {
        "NEW": "申请已受理。",
        "DOCS_REVIEW": "正在审核材料。",
        "NEEDS_MORE_DOCS": "需要补充材料，详情请在应用中查看。",
        "SUBMITTED": "材料已递交。",
        "DONE": "证件已办好！",
        "CANCELLED": "订单已取消。"
      }
    },
    "pro": {
      "offerTitle": "您有一个新订单",
      "offerTimeout": "请在 {{minutes}} 分钟内回复，否则订单将转给其他人。",
      "assignedByDispatcher": "调度员为您分配了 {{when}} 的订单。",
      "cancelled": "{{when}} 的订单已取消。",
      "rescheduled": "订单已改到 {{when}}。",
      "unassigned": "{{when}} 的订单已从您名下移除。",
      "reminder24": "明天有订单：{{when}}。",
      "reminder1": "一小时后有订单：{{when}}。",
      "orderEdited": "{{when}} 的订单已更新——请查看。"
    },
    "dispatcher": {
      "newOrder": "公司有新订单：{{when}}。请在工作台分配员工。",
      "returned": "员工拒绝了 {{when}} 的订单，请重新分配。",
      "noStaff": "{{when}} 的订单没有空闲员工——请在后台手动指派。",
      "expired": "{{when}} 的订单已退回 Barev Club：未能及时指派员工。"
    },
    "openPlan": "打开应用",
    "concierge": "Barev Club 礼宾",
    "subscriptionActivated": "{{plan}} 已开通，有效期至 {{date}}。服务价格已含折扣。",
    "operator": "Barev Club 客服",
    "support": "Barev Club 客服支持",
    "rateAsk": "服务体验如何？请花一秒钟评价一下：",
    "points": {
      "open": "我的 Bariki",
      "pending": "🪙 +{{amount}} Bariki（{{what}}，{{date}}）。{{available}} 起可用。",
      "active": "🪙 +{{amount}} Bariki（{{what}}）。余额：{{balance}}。",
      "bonus": "🎁 赠送 +{{amount}} Bariki：{{what}}。有效期至 {{until}}。",
      "bonusNoTtl": "🎁 赠送 +{{amount}} Bariki：{{what}}。",
      "housewarming": "来自 {{agency}} 的乔迁礼",
      "activated": "✅ {{amount}} Bariki 已可用。余额：{{balance}}。",
      "redeemed": "Bariki 已支付：{{amount}}。需补付：{{due}}。余额：{{balance}}。",
      "redeemedNoOrder": "已扣除 Bariki：{{amount}}。余额：{{balance}}。",
      "requestExpired": "您的 Bariki 支付申请已过期。如需要请重新发送。",
      "rejected": "您的 Bariki 支付申请被拒绝：{{reason}}",
      "declinedGeneric": "请在聊天中联系我们。",
      "orderCancelled": "订单已取消",
      "returned": "↩️ {{amount}} Bariki 已退回。余额：{{balance}}。",
      "reversed": "发放 {{what}} 已撤销：{{reason}}。余额：{{balance}}。",
      "expiring": "⏰ {{amount}} Bariki 将在 {{days}} 天后过期。任意订单即可保留。",
      "expired": "{{amount}} Bariki 因长期无订单已过期。",
      "orderEdited": "订单已修改——将按新金额发放"
    },
    "orderEdited": "您的订单已更新。应付总额：{{total}}。"
  },
  "admin": {
    "nav": {
      "orders": "订单",
      "clients": "客户",
      "providers": "服务人员",
      "companies": "服务合作方",
      "services": "服务与价格",
      "agencies": "房产中介",
      "settings": "设置",
      "presets": "费率",
      "webRequests": "网站申请",
      "leads": "搬家",
      "concierge": "礼宾",
      "requests": "应用申请",
      "partners": "俱乐部合作商家",
      "telegram": "通知",
      "templates": "搬家模板"
    },
    "roles": {
      "OWNER": "所有者",
      "OPERATOR": "客服"
    },
    "logout": "退出",
    "save": "保存",
    "saved": "已保存",
    "edit": "编辑",
    "add": "添加",
    "active": "启用",
    "copy": "复制",
    "copied": "已复制",
    "login": {
      "title": "登录后台",
      "email": "登录名或邮箱",
      "password": "密码",
      "submit": "登录",
      "totpTitle": "验证码",
      "setupTitle": "设置双重验证",
      "setupText": "用身份验证器（Google Authenticator、1Password）扫描二维码并输入验证码。",
      "qrAlt": "身份验证器二维码",
      "code": "应用中的验证码",
      "verify": "验证"
    },
    "summary": {
      "ordersToday": "今日订单",
      "unassigned": "未指派",
      "revenueToday": "今日收入",
      "freeProviders": "空闲 / 上班"
    },
    "kanban": {
      "title": "订单",
      "category": "类别",
      "allCategories": "全部类别",
      "service": "服务",
      "allServices": "全部服务",
      "date": "日期",
      "search": "搜索：编号、姓名、地址",
      "showCancelled": "已取消",
      "newOrderTitle": "新订单",
      "awaiting": "等待回复：{{name}}",
      "toCompany": "已指派给公司：{{name}}",
      "col": {
        "new": "新订单",
        "assigned": "已指派",
        "in_progress": "进行中",
        "done": "已完成",
        "cancelled": "已取消"
      }
    },
    "order": {
      "when": "时间",
      "min": "分钟",
      "params": "参数",
      "address": "地址",
      "note": "备注",
      "client": "客户",
      "agency": "中介",
      "provider": "服务人员",
      "price": "价格",
      "cancelFee": "扣款",
      "payment": "支付",
      "actions": "操作",
      "comment": "操作备注",
      "unassign": "取消指派",
      "confirmUnassign": "取消指派？订单将回到「新订单」。",
      "markPaid": "标记已付款",
      "confirmPaid": "确认已收到 {{amount}}？",
      "cancel": "取消订单",
      "confirmCancel": "取消订单？客户会收到通知。",
      "checklist": "清单",
      "photo": "照片",
      "history": "历史",
      "offers": "派单记录",
      "assignTitle": "指派",
      "assignTo": "指派给：{{name}}",
      "assign": "指派",
      "company": "公司",
      "noCandidates": "该时段没有空闲的服务人员。",
      "chooseManually": "手动选择（{{count}}）",
      "hideOthers": "收起",
      "busy": "忙碌",
      "load_one": "当天 {{count}} 单",
      "load_few": "当天 {{count}} 单",
      "load_many": "当天 {{count}} 单",
      "load_other": "当天 {{count}} 单",
      "offered": "订单已发送给服务人员",
      "statusChanged": "状态已更改",
      "cancelled": "订单已取消",
      "unassigned": "已取消指派",
      "paid": "已记录付款"
    },
    "reasons": {
      "language": "客户语言",
      "district": "区域",
      "onShift": "上班中",
      "lowLoad": "当天空闲"
    },
    "actors": {
      "CLIENT": "客户",
      "PROVIDER": "服务人员",
      "DISPATCHER": "调度员",
      "ADMIN": "客服",
      "SYSTEM": "系统"
    },
    "offerStatus": {
      "OFFERED": "等待回复",
      "ACCEPTED": "已接受",
      "DECLINED": "已拒绝",
      "EXPIRED": "已超时",
      "REVOKED": "已撤回"
    },
    "events": {
      "accepted": "服务人员已接单",
      "dispatcherAssigned": "调度员已分配员工",
      "assignedToCompany": "已转给公司",
      "offerDeclined": "服务人员拒绝",
      "offerExpired": "回复超时",
      "rescheduled": "改期",
      "unassigned": "已取消指派",
      "depart": "已出发",
      "arrived": "已到达",
      "startCleaning": "开始保洁",
      "finishCleaning": "保洁完成",
      "startWork": "开始工作",
      "closeRepair": "结束订单",
      "atPickup": "司机已到达上车点",
      "passengerIn": "乘客已上车",
      "finishRide": "行程结束",
      "scheduleLesson": "已排课",
      "openLesson": "课程已打开",
      "startLesson": "课程开始",
      "finishLesson": "课程结束",
      "openMeeting": "咨询已打开",
      "startMeeting": "咨询开始",
      "finishMeeting": "咨询结束",
      "editedByStaff": "团队修改了订单",
      "checklistByStaff": "团队勾选了清单项",
      "checklistUncheckedByStaff": "团队取消了清单项"
    },
    "weekdays": {
      "0": "周一",
      "1": "周二",
      "2": "周三",
      "3": "周四",
      "4": "周五",
      "5": "周六",
      "6": "周日"
    },
    "schedule": {
      "from": "从",
      "to": "到",
      "works": "工作日"
    },
    "rate": {
      "PERCENT": "订单百分比",
      "FIXED": "每单固定"
    },
    "providers": {
      "add": "添加服务人员",
      "name": "姓名",
      "phone": "电话",
      "role": "角色",
      "company": "公司",
      "freelancer": "个人服务者",
      "languages": "语言",
      "districts": "区域",
      "rate": "费率",
      "rateType": "费率类型",
      "ratePercent": "订单百分比",
      "rateFixed": "每单金额，֏",
      "companyRate": "公司费率",
      "rating": "评分",
      "schedule": "排班",
      "telegram": "Telegram",
      "linked": "已绑定",
      "resetInvite": "新邀请链接",
      "preset": "费率",
      "ownRate": "个人费率"
    },
    "companies": {
      "add": "添加公司",
      "name": "名称",
      "phone": "联系电话",
      "roles": "承接的订单类型",
      "employees": "员工",
      "dispatchers": "调度员",
      "dispatcherInvite": "调度员邀请链接"
    },
    "services": {
      "plusDiscount": "Barev+ 折扣",
      "active": "可预订",
      "inactive": "已隐藏",
      "availableToOrder": "开放预订",
      "prices": "价格与时长",
      "variant": "类型",
      "base": "1 个房间价格，֏",
      "perRoom": "每增加一个房间，֏",
      "baseMinutes": "1 个房间分钟数",
      "perRoomMinutes": "每增加一个房间的分钟数",
      "price": "价格，֏",
      "minutes": "时长，分钟",
      "lateFee": "晚取消扣款，%",
      "step": "时段间隔，分钟",
      "dayStart": "每日开始，时",
      "dayEnd": "每日结束，时",
      "leadHours": "最少提前小时数",
      "horizon": "可提前预订天数",
      "perBathroom": "每增加一个卫生间，֏",
      "perBathroomMinutes": "每个卫生间分钟数",
      "extras": "附加服务",
      "extra": "服务",
      "extraPrice": "价格，֏",
      "extraMinutes": "每单位分钟数",
      "eliteDiscount": "Elite 折扣"
    },
    "agencies": {
      "add": "添加房产中介",
      "name": "名称",
      "code": "代码",
      "commission": "佣金，%",
      "contact": "联系方式",
      "leads": "线索",
      "links": "二维码链接",
      "bot": "直达机器人",
      "landing": "经由官网",
      "hint": "客户自首次访问起 {{months}} 个月内归属该中介。佣金仅按已支付订单计算。"
    },
    "clients": {
      "name": "客户",
      "language": "语言",
      "source": "来源",
      "membership": "会员",
      "orders": "订单数",
      "since": "注册时间",
      "noConsent": "未同意",
      "source_organic": "自然流量",
      "source_deeplink": "中介链接",
      "source_manual_code": "手动输入代码",
      "grant": "+30 天 Barev+",
      "grantConfirm": "为该客户赠送 30 天 Barev+？",
      "grantElite": "Elite 30 天",
      "grantEliteConfirm": "为该客户开通 Barev Elite 30 天？",
      "segment_MOVING": "正在搬迁",
      "segment_LIVING": "住在亚美尼亚"
    },
    "settings": {
      "cancel_freeHours": "免费取消截止时间，提前小时数",
      "agency_attributionMonths": "客户归属中介，月",
      "agency_defaultCommissionPct": "默认中介佣金，%",
      "barevPlus_giftDays": "落地页：「前 N 天免费」（礼品本身在各中介中设置）",
      "barevPlus_monthlyPrice": "Barev+ 月费，֏",
      "offer_acceptTimeoutMinutes": "服务人员回复时限，分钟",
      "chat_closeAfterHours": "订单结束后聊天关闭，小时",
      "files_retentionDays": "证件扫描件保存，天",
      "consent_version": "隐私政策版本",
      "paymentMethods": "支付方式",
      "code": "代码",
      "name": "名称",
      "admins": "管理员",
      "role": "角色",
      "tempPassword": "临时密码（至少 10 个字符）",
      "addAdmin": "添加管理员",
      "disable": "停用",
      "enable": "启用",
      "barevPlus_maxDiscountPct": "Barev+：最高折扣，%",
      "elite_monthlyPrice": "Barev Elite：月费，֏",
      "elite_maxDiscountPct": "Barev Elite：最高折扣，%",
      "relocation_hotelWithPlus": "首页：Barev+ 会员酒店价，֏/晚",
      "relocation_hotelBase": "首页：非会员酒店价，֏/晚",
      "relocation_consultation": "首页：搬家咨询，֏",
      "docs_fromPrice": "/live：证件起价，֏",
      "docs_socialCardPrice": "社保卡全包服务，֏",
      "residence_escortFrom": "居留许可：陪同办理起价，֏",
      "residence_stateFee": "居留许可：1年国家规费，֏",
      "transfer_standardPrice": "接机「标准」，֏",
      "transfer_premiumPrice": "接机「高级」，֏",
      "assign_auto": "自动分配订单",
      "assign_maxAutoOffers": "自动尝试的服务人员数量",
      "sales_bonusPerVenue": "每个商户的销售奖金，֏",
      "sales_bonusPerAgency": "每个代理的销售奖金，֏",
      "sales_bonusAgencyPct": "销售奖金：其代理客户收入的百分比",
      "sales_bonusAgencyMonths": "……代理加入后的月数",
      "partner_fotPct": "合作方（费用由我们承担）：保洁员工资，订单的 %",
      "partner_taxPct": "合作方（费用由我们承担）：税费，%",
      "partner_minTravelGapMinutes": "合作方：员工两单之间的最短间隔，分钟",
      "partner_acceptTimeoutMinutes": "合作方：指派员工的时限（分钟），超时订单退回",
      "points_pendingHours": "Bariki：服务后 N 小时可用",
      "points_maxSharePct": "Bariki：最多支付订单的 N%",
      "points_minRedeem": "Bariki：每次最低使用",
      "points_burnDays": "Bariki：无活动 N 天后过期",
      "points_warnDays1": "Bariki：提前 N 天首次提醒",
      "points_warnDays2": "Bariki：提前 N 天再次提醒",
      "points_requestTtlHours": "Bariki：客户申请等待 N 小时",
      "points_streakGapDays": "Bariki：连续保洁——间隔不超过 N 天",
      "points_diffHighlightPct": "Bariki：手动金额偏差超过 N% 时高亮",
      "points_supportCanManage": "客服也可发放和扣除 Bariki（有限额）",
      "points_opMaxPerOperation": "客服单次操作限额（Bariki）",
      "points_opMaxPerDay": "客服每日限额（Bariki）",
      "barevPlus_monthlyPriceEur": "Barev+：在线支付月费，€",
      "elite_monthlyPriceEur": "Barev Elite：在线支付月费，€",
      "fx_eurAmd": "汇率：1 € 兑 ֏（订单换算为欧元）",
      "fx_eurRub": "汇率：1 € 兑 ₽（给客户的“≈ ₽”提示）"
    },
    "presets": {
      "add": "添加方案",
      "hint": "方案规定保洁员每一项价格的报酬：固定金额（֏）或百分比。百分比按 Barev+ 折扣前的价格计算。在服务人员资料中指定方案。",
      "providers_one": "{{count}} 名服务人员",
      "providers_few": "{{count}} 名服务人员",
      "providers_many": "{{count}} 名服务人员",
      "providers_other": "{{count}} 名服务人员",
      "room": "每增加一个房间",
      "bathroom": "每增加一个卫生间",
      "name": "方案名称",
      "applyAll": "统一百分比",
      "line": "价格项",
      "type": "类型",
      "value": "数值",
      "percent": "该项的 %",
      "fixed": "固定 {{unit}}",
      "perOrder": "每单",
      "perRoom": "每个房间",
      "perBathroom": "每个卫生间"
    },
    "webRequests": {
      "all": "全部",
      "status_NEW": "未打开机器人",
      "status_LINKED": "需要电话联系",
      "status_ORDERED": "已生成订单",
      "status_CANCELLED": "已取消",
      "number": "编号",
      "when": "期望时间",
      "what": "保洁",
      "contact": "联系人",
      "address": "地址",
      "price": "价格",
      "status": "状态",
      "note": "客服备注",
      "notePlaceholder": "已通话，需回电…",
      "saveNote": "保存",
      "cancel": "取消",
      "cancelConfirm": "取消申请 {{number}} 号？",
      "reopen": "恢复处理",
      "order": "订单 {{number}} 号",
      "created": "创建于 {{date}}",
      "empty": "暂无申请。有人在 barevclub.com/clean 填写表单后，申请会出现在这里。"
    },
    "leads": {
      "title": "搬家申请",
      "all": "全部",
      "empty": "暂无问卷申请。",
      "number": "编号",
      "contact": "联系方式",
      "plan": "时间",
      "package": "套餐",
      "status": "状态",
      "note": "备注",
      "created": "创建于 {{date}}",
      "unfinished": "未完成问卷",
      "moved": "已住在亚美尼亚",
      "status_NEW": "新申请",
      "status_IN_WORK": "处理中",
      "status_DONE": "已完成",
      "status_CANCELLED": "已取消",
      "budget": "{{from}}–{{to}} ֏/晚",
      "inApp": "已在应用中",
      "stepNote": "给客户的备注",
      "stepsInApp": "搬家计划：客户可在应用中查看步骤，状态变更时会收到消息",
      "stepsNoApp": "搬家计划：客户尚未打开应用",
      "addStep": "添加步骤",
      "addDoc": "添加证件",
      "custom": "自定义…",
      "customPlaceholder": "该客户的名称",
      "docsTitle": "客户证件——已准备 {{done}}/{{total}}",
      "remove": "从该客户移除",
      "removeStepConfirm": "从客户计划中移除步骤“{{name}}”？"
    },
    "concierge": {
      "empty": "暂无消息。客户给机器人发消息后，对话会显示在这里。",
      "placeholder": "回复会发送到客户与机器人的聊天中。⌘+Enter 发送",
      "replyLang": "客户语言：{{lang}}",
      "send": "发送",
      "you": "你",
      "client": "客户",
      "provider": "服务人员",
      "startHint": "暂无消息——可以先发消息，会发送到与机器人的聊天中。",
      "write": "发消息",
      "tab_all": "全部",
      "tab_clients": "客户",
      "tab_providers": "服务人员"
    },
    "partners": {
      "name": "名称",
      "category": "类别",
      "offer": "会员卡优惠",
      "address": "地址",
      "summary": "优惠：{{offers}} · 团队：{{members}} · 核验：{{visits}}",
      "manage": "优惠与团队",
      "offers": "分级优惠",
      "offerTitle": "优惠",
      "minLevel": "适用对象",
      "allMembers": "所有会员",
      "limit": "频次",
      "limitCount": "次数",
      "limitKind_NONE": "不限次数",
      "limitKind_ONCE": "仅首次到店",
      "limitKind_WEEK": "每周 N 次",
      "limitKind_MONTH": "每月 N 次",
      "limit_NONE": "不限次数",
      "limit_ONCE": "仅首次到店",
      "limit_WEEK": "每周 {{count}} 次",
      "limit_MONTH": "每月 {{count}} 次",
      "noOffers": "暂无优惠——客户只能看到合作伙伴简介。",
      "team": "所有者与员工",
      "ownerLink": "所有者链接",
      "ownerLinkHint": "发给所有者或让其扫描：打开工作机器人，点击 Start 后成为所有者，可邀请员工。一次性链接。",
      "noTeam": "尚无人连接。",
      "removeConfirm": "将此人与合作伙伴断开？"
    },
    "requests": {
      "activate": "开通 30 天",
      "activateConfirm": "开通 {{plan}} 30 天？",
      "client": "客户",
      "comment": "备注",
      "empty": "暂无申请。",
      "markDone": "已联系",
      "subscription": "{{plan}} 订阅",
      "what": "申请内容",
      "status_NEW": "新申请",
      "status_DONE": "已完成",
      "status_CANCELLED": "已取消"
    },
    "telegram": {
      "title": "Telegram：@{{bot}}",
      "linked": "已连接",
      "notLinked": "未连接",
      "what": "工作机器人会发送：",
      "e1": "客户和服务人员的消息——可直接在 Telegram 点击“回复”",
      "e2": "搬家申请——来自网站和应用",
      "e3": "应用申请——订阅和回电",
      "e4": "新订单和网站保洁申请",
      "how": "点击“连接”——打开工作机器人后点“Start”。每位客服用自己的账号同样连接。",
      "connect": "连接 Telegram",
      "relink": "连接其他 Telegram",
      "unlink": "断开",
      "notify": "发送通知"
    },
    "templates": {
      "STEP": "搬家步骤",
      "STEP_hint": "客户计划由此生成：全包取已标记的，自选取问卷中选择的",
      "DOC": "证件",
      "DOC_hint": "每位新客户都会得到的清单",
      "sub": "修改对新客户生效。单个客户的步骤和证件在“搬家”中修改。",
      "name": "名称",
      "hintField": "提示",
      "active": "对新客户显示",
      "inTurnkey": "包含在全包中",
      "turnkey": "全包",
      "hidden": "已隐藏",
      "missing": "缺少翻译：{{langs}}"
    }
  },
  "landing": {
    "meta": {
      "title": "Barev Club — 在埃里温，从第一天起就像在家",
      "description": "为移居埃里温的人提供保洁、证件、学习和合作伙伴折扣。全部在 Telegram 中完成，支持 5 种语言。"
    },
    "nav": {
      "label": "栏目",
      "services": "服务",
      "how": "使用流程",
      "plans": "会员",
      "faq": "常见问题"
    },
    "openTelegram": "在 Telegram 中打开",
    "hero": {
      "tag": "为移居埃里温的你",
      "title": "在埃里温，从第一天起就像在家。",
      "sub": "生活服务、证件、学习和合作伙伴优惠——尽在 Telegram 俱乐部。",
      "cta": "免费加入",
      "services": "查看服务",
      "cleanTitle": "公寓保洁 {{price}} 起",
      "cleanText": "一分钟算好价格、选好时间，无需打电话。",
      "cleanCta": "计算保洁价格"
    },
    "preview": {
      "title": "我的订单",
      "inApp": "应用内",
      "cleaning": "保洁 · 深度",
      "cleaningMeta": "周六 16:00",
      "inWork": "进行中",
      "lesson": "亚美尼亚语 A1 · 第 3 课",
      "lessonMeta": "今天 15:00 · 线上",
      "today": "今天",
      "cleaningRegular": "保洁 · 日常",
      "cleaningRegularMeta": "今天 12:30"
    },
    "languages": "种语言",
    "noInstall": "无需安装",
    "noInstallSub": "全部在 Telegram 内",
    "dir": {
      "HOME": "服务人员经过审核，订单状态在应用中查看。",
      "HOME_cta": "预订",
      "DOCS": "公证翻译，全程协助直到证件办好。",
      "DOCS_cta": "办理",
      "LEARNING": "线上线下皆可，时间灵活。",
      "LEARNING_cta": "报名",
      "soonCta": "上线时通知我"
    },
    "perks": {
      "upTo": "最高 −{{pct}}%",
      "cafes": "咖啡馆",
      "restaurants": "餐厅",
      "gifts": "合作伙伴礼品",
      "text": "结账时出示 Telegram 中的会员卡。",
      "cta": "查看合作伙伴"
    },
    "how": {
      "titleBold": "使用",
      "titleItalic": "流程",
      "step1": "扫描二维码",
      "step1_sub": "来自租房合同或官网",
      "step2": "选择语言",
      "step2_sub": "五种语言可选",
      "step3": "预订服务",
      "step3_sub": "时间、地址、支付",
      "step4": "跟踪状态",
      "step4_sub": "内置与服务人员聊天"
    },
    "agency": {
      "title": "通过合作房产中介租房？",
      "text": "一个月 Barev+ 的代码已写在合同里。",
      "gift": "礼品！",
      "giftSub": "1 个月 Barev+"
    },
    "plans": {
      "tryPlus": "试用 Barev+"
    },
    "faq": {
      "install": {
        "q": "需要安装什么吗？",
        "a": "不需要。俱乐部在 Telegram 内运行：打开机器人即可使用。"
      },
      "languages": {
        "q": "支持哪些语言？",
        "a": "俄语、英语、中文、亚美尼亚语和西班牙语。"
      },
      "plus": {
        "q": "Barev+ 和免费版有什么区别？",
        "a": "证件、生活服务、学习和职业咨询最高享 {{pct}}% 折扣。"
      },
      "gift": {
        "q": "如何领取房产中介的礼品？",
        "a": "代码在租房合同中。在机器人中输入代码，即可获得 {{days}} 天 Barev+。"
      }
    },
    "footer": {
      "brand": "Barev Club · 埃里温",
      "partner": "成为合作伙伴",
      "privacy": "隐私政策",
      "legal": "个体经营者 Yuri Zabudko · 税号（ՀՎՀՀ）{{tin}}",
      "services": "服务",
      "pricing": "价格",
      "terms": "使用条款",
      "refund": "取消与退款",
      "rules": "服务规则"
    },
    "clean": {
      "meta": {
        "title": "埃里温公寓保洁 — Barev Club",
        "description": "日常保洁、深度保洁和装修后保洁。价格即时可见，自选时间，在 Telegram 查看订单状态。"
      },
      "home": "首页",
      "title": "埃里温公寓保洁",
      "sub": "算好价格，选好时间。我们在 Telegram 确认申请并派保洁员上门。",
      "duration": "约 {{hours}} 小时",
      "extrasTitle": "附加服务",
      "extrasHint": "标准保洁之外需要做的事。",
      "whenTitle": "上门时间",
      "whenHint": "这是你希望的时间，具体时间我们会在 Telegram 确认。",
      "noTimes": "这一天已经没有可选时间，请看下一天。",
      "addressTitle": "地址",
      "district": "区",
      "districtPlaceholder": "选择区",
      "street": "街道、楼号、门牌号",
      "streetPlaceholder": "例如：Pushkin 10, 5 号",
      "note": "给保洁员的备注",
      "notePlaceholder": "门禁密码、宠物、钥匙放在哪里",
      "contactTitle": "联系方式",
      "phone": "电话",
      "phoneHint": "只有在 Telegram 联系不上时才会打电话。",
      "name": "怎么称呼你",
      "consent": "我同意处理我的个人数据",
      "privacy": "隐私政策",
      "summaryTitle": "你的保洁",
      "total": "合计",
      "plusHint": "Barev+ 会员保洁享 {{pct}}% 折扣",
      "submit": "提交申请",
      "sending": "正在提交…",
      "after": "提交后会打开 Telegram：我们在那里确认时间并显示状态。",
      "err": {
        "time": "请选择时间。",
        "district": "请选择区。",
        "street": "请填写街道和楼号。",
        "phone": "请填写带国家代码的电话，例如 +374 91 123456。",
        "consent": "没有你的同意，我们无法受理申请。",
        "network": "提交失败。请检查网络后重试。"
      },
      "doneTitle": "申请 {{number}} 号已收到",
      "doneText": "正在打开 Telegram，机器人会确认申请并显示状态。如果没有反应，请点击按钮。",
      "doneCta": "打开 Telegram",
      "doneAgain": "再提交一个申请",
      "includedTitle": "保洁包含",
      "zone": {
        "kitchen": "厨房",
        "bathroom": "卫生间",
        "rooms": "房间"
      },
      "inc": {
        "kitchen": "清洗水槽和水龙头\n擦拭灶台、台面和墙面\n擦拭橱柜门和电器外表\n拖地并倒垃圾",
        "bathroom": "清洗浴缸或淋浴、洗手盆和马桶\n擦亮镜子和水龙头\n擦拭置物架和门\n拖地",
        "rooms": "擦拭可触及表面的灰尘\n吸尘并拖地\n整理床铺和物品\n擦拭镜子和开关"
      },
      "general": "深度保洁：以上全部，外加难以清洁的地方——家具后面、踢脚线、门、暖气片和柜子内部。",
      "renovation": "装修后保洁：另外清除所有表面的建筑灰尘以及油漆、胶水和水泥痕迹。",
      "howTitle": "服务流程",
      "how1": "在这里提交申请",
      "how1Sub": "价格即时可见，无需打电话",
      "how2": "在 Telegram 确认",
      "how2Sub": "机器人显示订单和状态",
      "how3": "保洁员上门",
      "how3Sub": "按清单工作，并发送照片报告",
      "whenHintOptional": "可选：如不选择，机器人会在 Telegram 中询问。",
      "addressHintOptional": "可选：提交后也可以把地址发给机器人。",
      "nameTitle": "怎么称呼您",
      "consentByClick": "点击按钮即表示您同意处理个人数据。"
    },
    "v1": {
      "title": "在埃里温生活所需，一个聊天全搞定",
      "sub": "Barev Club 是一个 Telegram 机器人。说出需求，立刻看到价格并选择时间，其余交给我们。",
      "botName": "Barev Club",
      "botStatus": "机器人，即时回复",
      "u1": "你好！周六需要保洁，2 个房间",
      "b1": "你好！日常保洁，2 个房间和 1 个卫生间：{{price}}。周六 11:00 可以吗？",
      "u2": "可以，太好了",
      "b2": "已安排。保洁员 11:00 到达，状态和照片报告我会发到这里。",
      "canTitle": "可以预订什么",
      "canText": "保洁已经上线。其他服务陆续推出，上线时机器人会通知你。",
      "whyTitle": "为什么用 Telegram",
      "why1": "无需安装",
      "why1Sub": "机器人和应用直接在 Telegram 内打开。",
      "why2": "五种语言",
      "why2Sub": "俄语、英语、中文、亚美尼亚语和西班牙语。",
      "why3": "一切都在一个对话里",
      "why3Sub": "状态、与服务人员聊天和照片报告，都在你常用的地方。",
      "ctaTitle": "从“Barev”开始",
      "ctaText": "这是亚美尼亚语的“你好”。给机器人发消息，它会用你的语言回复。",
      "cta": "给机器人发消息"
    },
    "v2": {
      "hello": "Привет\nHello\n你好\nԲարև\nHola",
      "title": "搬到埃里温，一步一步来",
      "sub": "从机场到自己的公寓和证件。俱乐部在每一步陪着你，所有问题都在一个聊天里解决。",
      "calc": "计算价格",
      "ctaTitle": "俱乐部免费",
      "ctaText": "在 Telegram 加入，所有步骤触手可及，用你的语言。",
      "cta": "加入俱乐部",
      "whenArrive": "抵达",
      "whenWeek": "第一周",
      "whenSettled": "入住之后",
      "whenLater": "接下来",
      "whenDaily": "每天",
      "whenAnytime": "随时",
      "airportTitle": "机场接机并入住酒店",
      "airportText": "司机在兹瓦尔特诺茨机场举牌接你，送到酒店，头几天无忧无虑。",
      "flatTitle": "帮你找公寓",
      "flatText": "通过合作房产中介找房，入住前帮你做好保洁。",
      "docsTitle": "办理登记和社会卡",
      "docsText": "准备材料、预约，并陪你一直到拿到卡。",
      "permitTitle": "协助准备居留许可文件",
      "permitText": "整理材料、翻译公证，告诉你期限和递交流程。",
      "perksTitle": "享受俱乐部折扣和特权",
      "perksText": "凭俱乐部卡享受咖啡馆、餐厅和合作伙伴礼品；开通 Barev+ 还能享受服务折扣。",
      "chatTitle": "有任何问题，就在聊天里说",
      "chatText": "水龙头坏了，或者在亚美尼亚逾期停留了，写“救命！”，我们来处理并告诉你怎么办。",
      "chatChip": "在 Telegram",
      "chatCta": "在聊天里留言"
    },
    "v3": {
      "tag": "合作房产中介的租客专享",
      "title": "欢迎回家",
      "sub": "帮你租房的房产中介送你 Barev+ 订阅：保洁、证件和课程都有折扣。",
      "giftTitle": "Barev+ 1 个月",
      "giftCode": "代码 {{code}} 会自动生效",
      "giftNoCode": "代码在租房合同里",
      "stepsTitle": "如何领取",
      "step1": "点击“领取礼物”",
      "step1Sub": "会在 Telegram 打开 Barev Club 机器人。",
      "step2": "选择语言并确认同意",
      "step2Sub": "只需十秒钟。",
      "step3": "礼物自动生效",
      "step3Sub": "折扣立即用于你的订单。",
      "benefitsTitle": "一个月 Barev+ 能带来什么",
      "cleaningDeal": "保洁 {{price}} 起，原价 {{full}}",
      "cleaningDealSub": "日常保洁，价格已含折扣。",
      "cta": "领取礼物",
      "noCode": "没有代码？用 /code 发给机器人，或者直接加入：俱乐部免费。"
    },
    "v4": {
      "title": "刚到埃里温？接下来交给我们",
      "sub": "保洁、证件和亚美尼亚语课程，用你的语言在 Telegram 里预订，就像在这里住了很多年。",
      "board": "到达",
      "city": "埃里温",
      "colFlight": "航班",
      "colService": "服务",
      "colPrice": "价格",
      "colStatus": "状态",
      "live": "已开通",
      "soon": "即将推出",
      "passTitle": "登机牌",
      "passenger": "乘客",
      "passengerValue": "你",
      "from": "出发地",
      "fromValue": "任何地方",
      "to": "目的地",
      "toValue": "埃里温，像家一样",
      "gate": "登机口",
      "gateValue": "Telegram",
      "cta": "立即登机",
      "clean": "马上预订保洁"
    },
    "v5": {
      "title": "用 Barev+ 能省多少",
      "sub": "诚实计算：节省金额已扣除订阅费用。",
      "perMonth": "每月保洁次数",
      "without": "不用 Barev+",
      "with": "使用 Barev+",
      "withNote": "含订阅费 {{price}}",
      "save": "每月节省",
      "noSave": "目前不订阅更划算",
      "breakeven": "每月保洁 {{count}} 次（同等面积）起，Barev+ 就能回本。",
      "breakevenFirst": "同等面积的保洁，第一次就能让 Barev+ 回本。",
      "perYear": "一年：{{amount}}",
      "other": "订阅同样适用于其他服务类别",
      "cta": "试用 Barev+",
      "gift": "通过合作房产中介租的房？订阅免费赠送。"
    },
    "v6": {
      "tag": "致房产中介",
      "title": "一份关于你的租客如何在埃里温安顿下来的协议",
      "sub": "你送客户一个月 Barev+，我们帮他们处理日常琐事，你从他们的订单中获得分成。",
      "docDate": "埃里温",
      "s1": "房产中介获得什么",
      "s1i1": "客户首次打开机器人后 {{months}} 个月内，每笔订单的 {{pct}}%。",
      "s1i2": "专属代码和二维码，可放进租房合同或随钥匙一起交给客户。",
      "s1i3": "客户和订单报告：来了多少人、下单多少、你赚了多少。",
      "s2": "租客获得什么",
      "s2i1": "赠送 {{days}} 天 Barev+：保洁、证件和课程享受折扣。",
      "s2i2": "Telegram 内的五种语言服务，无需应用，无需电话。",
      "s2i3": "经过审核的服务人员，每个订单都有状态。",
      "s3": "如何加入",
      "s3i1": "在机器人里给我们留言，一天内回复。",
      "s3i2": "获取中介代码和二维码。",
      "s3i3": "把二维码放进租房合同，其余交给我们。",
      "exampleTitle": "示例",
      "exampleText": "{{clients}} 位客户 × 每月 {{orders}} 次保洁 × {{price}}",
      "exampleResult": "中介每月获得 {{amount}}",
      "exampleNote": "按两居室公寓的日常保洁计算。",
      "signAgency": "房产中介",
      "signUs": "Barev Club",
      "cta": "成为合作伙伴"
    },
    "home": {
      "metaTitle": "一站式搬到亚美尼亚：住房、社保卡、居留许可 — Barev Club",
      "metaDescription": "在兹瓦尔特诺茨机场接机，在埃里温找公寓，1天办好社保卡，办理登记和居留许可材料。一个 Telegram 聊天，支持 5 种语言。",
      "switchLabel": "本页面适合谁",
      "switchMove": "我要搬来",
      "switchLive": "我已住在亚美尼亚",
      "title": "搬到亚美尼亚，一步一步来",
      "sub": "机场接机、找房、办证件。所有问题都在一个聊天里解决，用你的语言。",
      "cta": "定制我的搬家方案",
      "ctaChat": "在 Telegram 联系我们",
      "whenArrive": "抵达",
      "whenFirst": "头几天",
      "whenSettled": "安顿之后",
      "whenLater": "之后",
      "whenDaily": "每天",
      "whenAnytime": "随时",
      "airportTitle": "机场接机并入住酒店",
      "airportText": "司机举牌在兹瓦尔特诺茨机场等候，送你到酒店——头几天无需操心。",
      "flatTitle": "帮你找房",
      "flatText": "1 天内给出房源，第二天安排看房。",
      "docsTitle": "办理登记和社保卡",
      "docsText": "准备材料，全程陪同到拿卡。社保卡第二天就能办好。",
      "permitTitle": "协助办理居留许可材料",
      "permitText": "通过就业途径：整理材料、翻译公证，并说明递交时间。",
      "perksTitle": "享受俱乐部折扣和特权",
      "perksText": "订阅 Barev+ 和 Barev Elite，享服务折扣和合作伙伴礼品。",
      "chatTitle": "有任何问题都可以发到聊天里",
      "chatText": "水龙头坏了，或在亚美尼亚逾期停留——写一句“救命！”，我们会帮你解决并告诉你怎么做。",
      "chatCta": "打开聊天",
      "finalTitle": "说说你的搬家计划",
      "finalText": "回答几个问题，我们就为你制定搬家方案并报价。",
      "more": "了解详情",
      "perksSoon": "即将推出"
    },
    "live": {
      "metaTitle": "埃里温生活服务会员折扣 — Barev Club",
      "metaDescription": "俱乐部订阅：保洁、维修、接送、游览和证件最高 {{pct}}% 折扣，语言课和职业咨询，合作伙伴礼品。",
      "title": "住在亚美尼亚？加入俱乐部更省钱",
      "sub": "订阅后，每月常用的服务都能享受折扣。",
      "cta": "订阅",
      "ctaPlans": "比较方案",
      "listTitle": "折扣适用范围",
      "listNote": "最高折扣需 Barev Elite。Barev+ 最高 {{pct}}%。",
      "upTo": "最高 −{{pct}}%",
      "discount": "折扣",
      "gifts": "礼品",
      "cleaning": "保洁",
      "cleaningHint": "日常、深度、装修后",
      "repair": "维修",
      "repairHint": "水管工、电工、小修",
      "transfer": "接送",
      "transferHint": "往返机场",
      "tours": "游览",
      "toursHint": "加尼、格加尔德、塞凡湖等",
      "docs": "证件",
      "docsHint": "社保卡、居留许可、登记、个体户和公司注册",
      "lang": "语言",
      "langHint": "英语和亚美尼亚语",
      "career": "职业",
      "careerHint": "简历、LinkedIn 资料、面试准备",
      "partners": "合作伙伴",
      "partnersHint": "俱乐部合作的咖啡馆、餐厅和商店",
      "finalTitle": "在 Telegram 中订阅",
      "finalText": "打开俱乐部机器人，选择方案——服务价格会自动显示折扣。",
      "orderNow": "立即预约",
      "docsFrom": "订阅价 {{price}} 起"
    },
    "club": {
      "title": "俱乐部订阅",
      "sub": "下单服务免费。折扣和礼宾服务需订阅。",
      "free": "免费",
      "perMonth": "{{price}}/月",
      "freeF1": "在 Telegram 机器人中下单和查看进度",
      "freeF2": "每个订单都可支付和聊天",
      "freeF3": "服务按原价",
      "plusF1": "服务最高 −{{pct}}%",
      "plusF2": "合作伙伴礼品",
      "plusF3": "工作日 10:00–18:00 聊天礼宾服务",
      "eliteF1": "服务最高 −{{pct}}%",
      "eliteF2": "合作伙伴礼品",
      "eliteF3": "24/7 聊天礼宾服务——任何问题都能解决",
      "freeCta": "打开机器人",
      "plusCta": "订阅 Barev+",
      "eliteCta": "订阅 Elite"
    },
    "quiz": {
      "dialog": "定制搬家方案",
      "close": "关闭",
      "back": "返回",
      "next": "下一步",
      "progress": "第 {{n}} 步，共 {{total}} 步",
      "sending": "保存中…",
      "contactTitle": "怎么称呼你？",
      "name": "姓名",
      "contact": "电话或 Telegram",
      "contactHint": "+374 … 或 @username",
      "consentPre": "点击“下一步”即表示你同意",
      "consentLink": "隐私政策",
      "errName": "请告诉我们怎么称呼你。",
      "errContact": "请填写电话（+374…）或 Telegram 用户名（@username）。",
      "movedTitle": "你已经搬到亚美尼亚了吗？",
      "movedYes": "是的，已经住在这里",
      "movedNo": "还没有，正在计划",
      "movingToLive": "正在打开亚美尼亚居民专属页面…",
      "whenTitle": "你计划什么时候搬来？",
      "when_month": "一个月内",
      "when_quarter": "1–3 个月后",
      "when_later": "更晚，还在考虑",
      "when_date": "已确定日期",
      "date": "抵达日期",
      "errWhen": "请选择一个选项或填写日期。",
      "packageTitle": "你需要哪种服务套餐？",
      "package_CONSULT": "仅咨询",
      "package_CONSULT_text": "分析你的情况，制定搬家计划。",
      "package_TURNKEY": "全包",
      "package_TURNKEY_text": "从机场接机到居留许可或登记。我们会根据需求精确报价。",
      "package_TURNKEY_price": "按需报价",
      "package_CUSTOM": "自己组合",
      "package_CUSTOM_text": "只选你需要的服务。",
      "customTitle": "组合你的套餐",
      "airport": "机场接机",
      "airport_none": "不需要",
      "airport_standard": "标准",
      "airport_premium": "高级",
      "stay": "初期住宿",
      "stay_none": "不需要",
      "stay_flat": "公寓",
      "stay_hotel": "酒店",
      "budget": "每晚预算，֏",
      "budgetFrom": "从",
      "budgetTo": "到",
      "flat": "找房",
      "socialCard": "社保卡",
      "bankCard": "银行卡",
      "registration": "登记",
      "residence": "居留许可",
      "no": "不需要",
      "yes": "需要",
      "yesHint": "我们会联系你确认细节",
      "errEmpty": "请至少选择一项服务。",
      "submit": "提交申请",
      "doneTitle": "已收到第 {{number}} 号申请",
      "doneText": "我们会在一天内联系你：{{contact}}。",
      "doneBot": "在 Telegram 打开俱乐部",
      "doneClose": "返回网站",
      "errNetwork": "无法连接服务器。请检查网络后重试。"
    },
    "seo": {
      "org": "Barev Club 是为搬到埃里温或已在亚美尼亚生活的人提供的会员服务：机场接机、住房、社保卡、居留许可、保洁和合作商家折扣。全部在 Telegram 中完成，支持 5 种语言。"
    },
    "svc": {
      "common": {
        "home": "首页",
        "updated": "更新于2026年10月20日",
        "factsTitle": "要点",
        "pricesTitle": "价格",
        "faqTitle": "常见问题",
        "relatedTitle": "更多搬迁服务",
        "cta": "在 Telegram 联系我们",
        "ctaMove": "一站式搬迁",
        "clean": "公寓保洁",
        "breadcrumbs": "导航"
      },
      "socialCard": {
        "meta": {
          "title": "亚美尼亚外国人社保卡：所需材料、时间和价格 — Barev Club",
          "description": "2026年如何在亚美尼亚办理社保卡（公共服务号码 ՀԾՀ）：需要哪些材料、去哪里办、要等多久。我们全程代办，{{price}}，通常1天完成。"
        },
        "crumb": "社保卡",
        "h1": "亚美尼亚社保卡：1天办好",
        "lead": "社保卡即公共服务号码（ՀԾՀ），共10位数字。没有它，在亚美尼亚无法开银行账户、注册个体经营者或申请居留许可。外国人可在移民局下属办事处办理，通常当天出号。Barev Club 全程代办，{{price}}：护照翻译、预约和陪同。",
        "priceLabel": "全程代办",
        "priceValue": "{{price}}",
        "priceNote": "含护照翻译、公证、预约和陪同",
        "facts": {
          "f1": {
            "label": "时间",
            "value": "通常1天"
          },
          "f2": {
            "label": "价格",
            "value": "全程 {{price}}"
          },
          "f3": {
            "label": "办理机构",
            "value": "内政部移民局办事处"
          },
          "f4": {
            "label": "您需要准备",
            "value": "带入境章的护照"
          }
        },
        "stepsTitle": "我们如何办理",
        "steps": {
          "s1": {
            "when": "第1天",
            "title": "在 Telegram 联系我们",
            "text": "发送护照照片和您在埃里温的地址。租住的公寓或酒店地址都可以。"
          },
          "s2": {
            "when": "第1天",
            "title": "办理公证翻译",
            "text": "我们将护照首页翻译成亚美尼亚语并办理公证。"
          },
          "s3": {
            "when": "第1天",
            "title": "预约办事处",
            "text": "选择排队短的办事处和您方便的时间。"
          },
          "s4": {
            "when": "第1–2天",
            "title": "陪同前往",
            "text": "陪同人员会说亚美尼亚语并代填申请表。您只需带护照到场。"
          },
          "s5": {
            "when": "第1–2天",
            "title": "拿到号码",
            "text": "号码证明通常当场发放，有时次日领取。"
          }
        },
        "blocks": {
          "b1": {
            "title": "什么是社保卡",
            "body": "“社保卡”是公共服务号码（ՀԾՀ，Public Services Number）的俗称。这是国家分配给亚美尼亚公民和在该国合法停留的外国人的唯一10位号码。\n外国人领取的不是塑料卡，而是一份载有号码的证明。如果您已有居留许可，号码可能已印在居留卡上。"
          },
          "b2": {
            "title": "为什么需要",
            "body": "• 在亚美尼亚开立银行账户和银行卡；\n• 注册个体经营者或有限责任公司；\n• 依法纳税和领取工资；\n• 申请居留许可；\n• 在公立诊所预约医生；\n• 购车并办理亚美尼亚驾照。"
          },
          "b3": {
            "title": "所需材料",
            "body": "• 带亚美尼亚入境章的护照。\n• 护照首页的亚美尼亚语公证翻译——由我们办理。\n• 在亚美尼亚的地址：租住的公寓或酒店均可，无需登记。\n• 如果您持俄罗斯国内护照入境，还需该护照的公证翻译，可能多花几天。\n有时办事处会要求出生证明或登记证明。如有需要，我们会提前告知。"
          },
          "b4": {
            "title": "2026年11月1日起的变化",
            "body": "2026年11月1日起，亚美尼亚新的《外国人法》生效，移民局的预约系统也随之调整。我们会跟进变化，按现行规定为您预约。"
          }
        },
        "prices": {
          "p1": {
            "name": "社保卡全程代办",
            "value": "{{price}}",
            "note": "护照翻译、公证、预约、陪同"
          },
          "p2": {
            "name": "Barev+ 会员",
            "value": "−{{docsPct}}%",
            "note": "所有证件类服务均享折扣"
          }
        },
        "faq": {
          "q1": {
            "q": "没有居留许可能办社保卡吗？",
            "a": "可以。在亚美尼亚合法停留的外国人（例如凭入境章）即可办理，不需要居留许可。"
          },
          "q2": {
            "q": "办理社保卡需要多长时间？",
            "a": "大多数办事处当天出证，部分办事处次日领取。我们会提前准备护照公证翻译，因此通常1–2天即可完成。"
          },
          "q3": {
            "q": "需要会说亚美尼亚语吗？",
            "a": "不需要。会有懂亚美尼亚语和英语或俄语的陪同人员与您同去，并代您填写申请表。"
          },
          "q4": {
            "q": "不本人到场能办社保卡吗？",
            "a": "可由持委托书的代理人领取；如有亚美尼亚电子签名，也可在线办理。如果您不在埃里温，请联系我们，我们会想办法。"
          },
          "q5": {
            "q": "社保卡和税号（ՀՎՀՀ）有什么区别？",
            "a": "社保卡（ՀԾՀ）是个人号码，ՀՎՀՀ 是个体经营者和公司获得的纳税人号码。注册个体经营者之前，需要先有社保卡。"
          }
        },
        "finalTitle": "需要办社保卡？",
        "finalText": "在 Telegram 联系我们——我们会预约最近的合适日期并翻译您的护照。"
      },
      "residence": {
        "meta": {
          "title": "2026年亚美尼亚居留许可：11月1日起新规、申请依据和费用 — Barev Club",
          "description": "如何依据新法申请亚美尼亚居留许可：工作、个体经营、有限责任公司、家庭。国家规费 {{fee}}，在线申请。咨询 {{consult}}，全程陪同 {{escort}} 起。"
        },
        "crumb": "居留许可",
        "h1": "2026年亚美尼亚居留许可：有哪些变化，如何办理",
        "lead": "自2026年11月1日起，亚美尼亚新的《外国人法》生效。居留许可改为在线申请，首次签发1年期，国家规费上调至 {{fee}}。申请依据包括工作、个体经营、有限责任公司、学习或家庭。Barev Club 帮您选择依据，并全程陪同直到拿到居留卡。",
        "priceLabel": "全程陪同",
        "priceValue": "{{escort}} 起",
        "priceNote": "另付国家规费 {{fee}}；{{consult}} 咨询费可抵扣",
        "facts": {
          "f1": {
            "label": "新规",
            "value": "2026年11月1日起"
          },
          "f2": {
            "label": "国家规费",
            "value": "1年期 {{fee}}"
          },
          "f3": {
            "label": "申请方式",
            "value": "在线申请 + 一次到场录指纹"
          },
          "f4": {
            "label": "全程陪同",
            "value": "{{escort}} 起"
          }
        },
        "stepsTitle": "我们如何办理居留许可",
        "steps": {
          "s1": {
            "when": "第1周",
            "title": "咨询",
            "text": "了解您的情况并选择依据：工作、个体经营、有限责任公司或家庭。{{consult}} 的咨询费可抵扣全程陪同费用。"
          },
          "s2": {
            "when": "第1–2周",
            "title": "准备依据",
            "text": "协助您注册个体经营者或公司、存入所需金额或签订劳动合同。"
          },
          "s3": {
            "when": "第2–3周",
            "title": "准备材料",
            "text": "翻译并公证材料；如果您还没有社保卡，一并办理。"
          },
          "s4": {
            "when": "递交",
            "title": "在线申请",
            "text": "在政府门户网站填写申请，并回复移民局的补件要求。"
          },
          "s5": {
            "when": "到场",
            "title": "录指纹",
            "text": "需本人到移民局一次，录指纹并签字。我们陪您同去。"
          },
          "s6": {
            "when": "完成",
            "title": "领取居留卡",
            "text": "告知您审批结果并协助领取居留卡。"
          }
        },
        "blocks": {
          "b1": {
            "title": "2026年11月1日起的变化",
            "body": "• 修订后的《外国人法》于2026年1月20日通过，自2026年11月1日起施行。\n• 申请通过统一门户在线提交。本人只需到场一次录指纹并签字，委托书不能代替。\n• 首次签发1年期居留许可。在最近5年内持有3年临时居留后，可申请5年期永久居留。\n• 1年期居留许可规费为15万德拉姆，另加5,950德拉姆卡费；永久居留为255,950德拉姆。\n• 政府实行年度配额，配额用完后不再受理新申请。\n• 不再为亚美尼亚族人签发10年期特殊身份，已签发的证件在有效期内继续有效。\n• 11月1日前递交的申请按旧规审理。已签发的居留许可有效期至卡面日期，续签时适用新规。"
          },
          "b2": {
            "title": "居留许可的申请依据",
            "body": "• 工作：与亚美尼亚公司签订劳动合同。劳动力市场测试已取消，改为配额。\n• 个体经营：申请时亚美尼亚银行账户中有100万德拉姆，或申请前60天营业额达到同等金额。\n• 有限责任公司：注资或购买股份不少于200万德拉姆。如获批后180天内没有任何纳税记录，居留许可可被注销。\n• 学习：不仅限于大学，也包括培训课程、职业教育和交换项目。\n• 家庭：亚美尼亚公民或持居留身份外国人的配偶、父母或子女。\n仅购买公寓本身不能获得居留许可。"
          },
          "b3": {
            "title": "需要准备的材料",
            "body": "• 护照及其亚美尼亚语公证翻译；\n• 依据证明：劳动合同、个体经营者或公司注册文件、银行证明、结婚或出生证明；\n• 社保卡（公共服务号码）；\n• 国家规费缴费凭证。\n具体清单由政府法规规定，咨询时我们会核对最新版本。"
          },
          "b4": {
            "title": "没有居留许可能在亚美尼亚居住吗？",
            "body": "俄罗斯公民免签入境，每次入境可停留最多180天。其他国家公民按各自规定执行。如果停留期限即将到期而尚未取得居留许可，逾期可能被罚款。请尽早联系我们，我们会告诉您还能做什么。"
          },
          "b5": {
            "title": "请注意",
            "body": "以上信息截至2026年10月20日。部分规定仍在通过配套法规细化，因此每次递交前我们都会向移民局核实要求。本页内容不构成法律意见。"
          }
        },
        "prices": {
          "p1": {
            "name": "咨询",
            "value": "{{consult}}",
            "note": "可抵扣全程陪同费用"
          },
          "p2": {
            "name": "全程陪同至领卡",
            "value": "{{escort}} 起",
            "note": "依据、材料、递交、到场"
          },
          "p3": {
            "name": "1年期居留国家规费",
            "value": "{{fee}}",
            "note": "缴给国家，2026年11月1日起"
          },
          "p4": {
            "name": "5年期居留国家规费",
            "value": "255,950 ֏",
            "note": "需先持有3年临时居留"
          }
        },
        "faq": {
          "q1": {
            "q": "2026年办理亚美尼亚居留许可要多少钱？",
            "a": "自2026年11月1日起，1年期居留许可国家规费为 {{fee}}：15万德拉姆规费加5,950德拉姆卡费。以个体经营为依据的，还需账户中有100万德拉姆或60天内同等营业额。Barev Club 全程陪同 {{escort}} 起。"
          },
          "q2": {
            "q": "居留许可审批要多久？",
            "a": "移民局尚未公布新系统的审批时限。待新规下的首批审批结果出来后，我们会在咨询时告诉您实际所需时间。"
          },
          "q3": {
            "q": "在亚美尼亚买房能获得居留许可吗？",
            "a": "不能。根据新法，拥有房产本身不能获得居留许可，需要有工作、经营、学习或家庭关系。"
          },
          "q4": {
            "q": "需要本人到场吗？",
            "a": "需要，一次：在亚美尼亚录指纹并在申请上签字。委托书不能代替，其余步骤均可在线完成。"
          },
          "q5": {
            "q": "我已有的居留许可会怎样？",
            "a": "在卡面有效期内继续有效。续签时适用新规、新规费和在线申请。"
          },
          "q6": {
            "q": "可以直接拿5年期居留许可吗？",
            "a": "通常不行：先获得1年期居留许可，在最近5年内持有3年临时居留后才能申请永久居留。例外情况包括亚美尼亚族人、投资者以及对亚美尼亚有特殊贡献的人。"
          }
        },
        "finalTitle": "帮您分析具体情况",
        "finalText": "在 Telegram 告诉我们您的情况——我们会选择合适的依据并计算全部费用。"
      },
      "airport": {
        "meta": {
          "title": "兹瓦尔特诺茨机场至埃里温接机服务 — Barev Club",
          "description": "在兹瓦尔特诺茨机场举牌接机，帮您搬行李，送到埃里温的住所或酒店。标准 {{standard}}，高级 {{premium}}。航班跟踪，免费等待60分钟。"
        },
        "crumb": "机场接送",
        "h1": "兹瓦尔特诺茨机场举牌接机",
        "lead": "司机在兹瓦尔特诺茨机场到达大厅举牌迎接，帮您搬运行李，并送您到埃里温的任何地址。到市中心约20–30分钟。标准车型每车 {{standard}}，最多3位乘客；高级车型 {{premium}}。我们会跟踪航班，前60分钟等待免费。",
        "priceLabel": "标准接机",
        "priceValue": "{{standard}}",
        "priceNote": "最多3位乘客，举牌接机，等待60分钟",
        "facts": {
          "f1": {
            "label": "接机地点",
            "value": "到达大厅，举牌迎接"
          },
          "f2": {
            "label": "到市中心",
            "value": "20–30分钟"
          },
          "f3": {
            "label": "标准",
            "value": "{{standard}}"
          },
          "f4": {
            "label": "高级",
            "value": "{{premium}}"
          }
        },
        "stepsTitle": "接机流程",
        "steps": {
          "s1": {
            "when": "出发前",
            "title": "发送航班号",
            "text": "在 Telegram 发送航班号、乘客人数、行李件数和埃里温地址。"
          },
          "s2": {
            "when": "出发前",
            "title": "获取司机信息",
            "text": "我们发送司机姓名、车牌号，并在机器人中建立与司机的聊天。"
          },
          "s3": {
            "when": "到达",
            "title": "跟踪航班",
            "text": "如果航班延误，司机会按新时间到达，无需加钱。"
          },
          "s4": {
            "when": "到达",
            "title": "举牌迎接",
            "text": "司机在到达大厅举着写有您名字的牌子等候，并帮您搬运行李。"
          },
          "s5": {
            "when": "30分钟后",
            "title": "抵达目的地",
            "text": "送您到埃里温的公寓或酒店。"
          }
        },
        "blocks": {
          "b1": {
            "title": "服务包含",
            "body": "• 到达大厅举牌迎接；\n• 帮忙搬运行李；\n• 标准车型最多3位乘客；\n• 航班跟踪；\n• 落地后免费等待60分钟；\n• 通过机器人与司机聊天。\n高级车型另含商务级车辆、车内饮用水和亚美尼亚运营商 SIM 卡，落地即可联网。"
          },
          "b2": {
            "title": "头几天的酒店",
            "body": "如果还没有公寓，我们可以预订酒店并直接送您过去。Barev+ 会员每晚 {{hotelPlus}} 起，非会员 {{hotelBase}} 起。"
          },
          "b3": {
            "title": "从兹瓦尔特诺茨出行的其他方式",
            "body": "• 机场柜台出租车：据旅行指南，到市中心通常3,000–7,000德拉姆，但没有人在到达大厅迎接。\n• 打车软件（如 Yandex Go）：便宜，但需要自己在停车场找车。\n• 接机服务价格更高，但司机在到达大厅等候、跟踪航班并帮忙搬行李。适合携家人出行、深夜抵达或第一次来亚美尼亚的旅客。"
          }
        },
        "prices": {
          "p1": {
            "name": "标准",
            "value": "{{standard}}",
            "note": "最多3位乘客，举牌，等待60分钟"
          },
          "p2": {
            "name": "高级",
            "value": "{{premium}}",
            "note": "商务车、饮用水、SIM 卡"
          },
          "p3": {
            "name": "Barev+ 会员酒店",
            "value": "{{hotelPlus}} 起",
            "note": "每晚；非会员 {{hotelBase}} 起"
          },
          "p4": {
            "name": "Barev+ 会员",
            "value": "−{{homePct}}%",
            "note": "接送及生活服务折扣"
          }
        },
        "faq": {
          "q1": {
            "q": "从兹瓦尔特诺茨机场到埃里温市中心接机多少钱？",
            "a": "Barev Club 标准接机每车 {{standard}}，最多3位乘客，含举牌迎接；高级车型 {{premium}}。机场柜台出租车通常3,000–7,000德拉姆，但没有到达大厅接机。"
          },
          "q2": {
            "q": "航班延误怎么办？",
            "a": "我们会跟踪航班，司机按实际落地时间到达。落地后前60分钟等待免费。"
          },
          "q3": {
            "q": "从机场到埃里温市中心要多久？",
            "a": "不堵车约20–30分钟：兹瓦尔特诺茨机场位于市中心以西约12公里。"
          },
          "q4": {
            "q": "可以预订送机吗？",
            "a": "可以。从埃里温任何地址送您到兹瓦尔特诺茨机场，价格相同。"
          },
          "q5": {
            "q": "如何预订接机？",
            "a": "在 Telegram 发送航班号、乘客人数和地址，最好在落地前至少一天预订。"
          }
        },
        "finalTitle": "要飞埃里温吗？",
        "finalText": "在 Telegram 发送航班号——我们接机并送您到家门口。"
      }
    },
    "pay": {
      "cardCta": "刷卡支付",
      "redirecting": "正在打开支付页面…",
      "orTelegram": "或在 Telegram 中开通",
      "approx": "≈ {{amd}} · ≈ {{rub}}，以欧元支付，自动续费",
      "error": "无法打开支付页面。请重试，或在 Telegram 中开通。",
      "metaTitle": "会员付款 — Barev Club",
      "checking": "正在确认付款…",
      "pendingTitle": "正在等待付款确认",
      "pendingText": "通常只需几秒钟，页面会自动刷新。",
      "backToPayment": "返回支付",
      "paidTitle": "付款成功！{{plan}} 等待激活",
      "paidText": "俱乐部在 Telegram 中运行。点击按钮，机器人会把会员绑定到你的账号，折扣立即生效。",
      "activate": "在 Telegram 中激活",
      "renewNote": "会员每月以 {{price}} 自动续费。可在应用的“会员”中关闭续费。",
      "claimedTitle": "{{plan}} 已激活",
      "claimedText": "会员已绑定到你的 Telegram。打开机器人，折扣已生效。",
      "openBot": "打开机器人",
      "failedTitle": "付款失败",
      "failedText": "未扣款。请重试或换一张卡。",
      "retry": "重试",
      "refundedTitle": "款项已退回",
      "notFoundTitle": "未找到付款",
      "notFoundText": "请检查链接或联系我们，我们会帮忙。"
    }
  },
  "privacy": {
    "title": "隐私政策",
    "updated": "2026 年 10 月 22 日版本",
    "intro": "本政策说明 Barev Club 收集哪些个人数据、用途、与谁共享，以及您如何管理这些数据。本政策适用于 barevclub.com 网站、Barev Club 的 Telegram 机器人和小程序。",
    "operator": {
      "title": "谁处理您的数据",
      "body": "个人数据处理者为个体经营者 Yuri Konstantinovich Zabudko（Ա/Ձ Զաբուդկո Յուրի Կոնստանտինի），亚美尼亚共和国，税号（ՀՎՀՀ）{{tin}}。Barev Club 是本服务的名称。\n如有数据相关问题，请发邮件至 {{email}}、拨打 {{phone}} 或在机器人聊天中留言。"
    },
    "data": {
      "title": "我们获取哪些数据",
      "body": "• 来自 Telegram：ID、用户名、个人资料中的姓名、语言。电话号码仅在您主动分享时获取。\n• 网站申请：姓名、电话或 Telegram 用户名、搬迁规划中的回答（时间、所需服务、预算）。保洁服务另需地址、区域、期望时间和备注。\n• 订单：地址和区域、地图位置（如您提供）、服务参数、日期和时间、价格、折扣、付款状态、备注。\n• 证件：您为“证件”类服务上传的护照及其他证件扫描件。\n• 通过机器人与服务人员的聊天记录、照片报告、评分和评价。\n• 会员信息：等级（Barev、Barev+、Elite）、订阅期限、会员卡代码及在合作商家处的使用记录。\n• 来源：您通过的中介机构或优惠码，以及广告活动标记（UTM）。\n• 技术数据：保存网站语言的 cookie、浏览器存储中的中介代码，以及用于防范故障和攻击的服务器日志（IP 地址、请求时间和地址）。\n我们不获取银行卡信息：在线支付时，卡信息在支付服务 Tribute（tribute.tg）的页面上填写。"
    },
    "purposes": {
      "title": "我们为什么使用这些数据",
      "body": "• 受理并完成订单：安排服务人员、计算价格、通知订单状态。\n• 就您的申请与您联系并制定搬迁计划。\n• 管理会员订阅、会员卡和折扣。\n• 计算推荐您的中介机构的佣金和服务人员的报酬。\n• 进行会计和税务记录。\n• 根据评分和评价改进服务。\n• 在您未退订的情况下发送俱乐部新闻和优惠。"
    },
    "basis": {
      "title": "法律依据",
      "body": "我们基于您在机器人或网站表单中给予的同意处理数据，同时为履行您的订单并遵守亚美尼亚共和国法律，包括《个人数据保护法》。\n您可以随时撤回同意，这不影响撤回前已进行的处理。"
    },
    "recipients": {
      "title": "我们与谁共享数据",
      "body": "我们不出售个人数据，只共享具体任务所需的信息：\n• 您订单的服务人员；如由合作公司完成，还包括该公司的调度员：姓名、语言、地址和订单详情。您的电话号码不会显示给服务人员，沟通通过机器人进行。\n• 推荐您的房产中介：姓名、是否使用俱乐部服务以及已付款订单金额，用于计算中介佣金。\n• 您出示会员卡时的俱乐部合作商家：姓名和会员等级。\n• Telegram：机器人和小程序在其上运行，Telegram 按其自身政策处理数据。\n• Hostinger International：数据库和文件存储在其服务器上。\n• 处理在线支付的支付服务 Tribute（tribute.tg）：电子邮箱（如你提供）、金额、付款用途和内部客户编号。Tribute 按其自身隐私政策在其一侧处理银行卡信息。\n• 政府机关：当您订购证件服务、我们代您提交材料时，或法律要求时。"
    },
    "location": {
      "title": "数据存储在哪里",
      "body": "数据库和文件存储在德国的服务器上（美因河畔法兰克福，服务商 Hostinger）。德国是欧盟成员国，适用《通用数据保护条例》（GDPR）。\n给予同意即表示您同意将数据传输至亚美尼亚境外。Telegram 可能在其他国家处理数据。"
    },
    "retention": {
      "title": "我们保存数据多久",
      "body": "• 个人资料：在您使用服务期间或直至您要求删除。\n• 订单和付款：订单完成后保存 5 年，这是会计和税务规定的要求。\n• 与服务人员的聊天记录和照片报告：订单完成后保存 1 年。\n• 未形成订单的网站申请：保存 12 个月。\n• 证件扫描件：订单完成后保存 90 天，之后自动删除。\n期限届满后，数据将被删除或匿名化。"
    },
    "security": {
      "title": "我们如何保护数据",
      "body": "• 网站和应用仅通过 HTTPS 运行。\n• 证件扫描件存储在加密存储中，只有运营人员和指派的服务人员可通过临时链接查看，每次查看都会记录。\n• 管理后台登录受密码和双重验证保护，管理员操作均有记录。\n• 我们每天备份数据库。"
    },
    "rights": {
      "title": "您的权利",
      "body": "您可以：\n• 了解我们持有您的哪些数据并获取副本；\n• 更正不准确的数据；\n• 删除您的数据和个人资料，法律要求我们保存的数据除外；\n• 撤回数据处理同意；\n• 退订新闻和优惠；\n• 向亚美尼亚共和国司法部个人数据保护局投诉。\n请发邮件至 {{email}} 或在机器人聊天中留言。我们将在亚美尼亚共和国法律规定的期限内答复。没有数据处理同意，我们将无法接受新订单。"
    },
    "marketing": {
      "title": "新闻和优惠",
      "body": "我们会不时在机器人中发送俱乐部新闻、促销和合作商家优惠。您可以随时退订：在机器人聊天中发送“退订”或发邮件至 {{email}}。\n有关订单、订阅和预约提醒的消息不受影响，照常发送。"
    },
    "cookies": {
      "title": "Cookie",
      "body": "网站只设置一个 cookie：barev_lang，用于保存您选择的语言，下次以该语言打开。如果您通过中介链接访问，其代码会保存在浏览器存储中，以免折扣丢失。网站不使用广告或分析类 cookie。"
    },
    "age": {
      "title": "年龄",
      "body": "本服务面向成年人。如果您未满 18 岁，请不要向我们提供您的数据。儿童的数据（例如用于家庭证件）由父母或法定监护人提供并负责。"
    },
    "changes": {
      "title": "政策变更",
      "body": "我们可能会更新本政策。现行版本始终在本页面，版本日期标注在开头。重大变更我们会在机器人中通知您。\n俄语文本为正式版本，其他语言译文仅为方便阅读。"
    }
  },
  "pricing": {
    "title": "价格",
    "updated": "自 2026 年 10 月 22 日起生效",
    "intro": "Barev Club 会员和俱乐部服务的价格。不订阅会员也可以下单，会员只是额外提供折扣和礼宾服务。所有价格均以亚美尼亚德拉姆（֏）计。",
    "from": "{{price}} 起",
    "perDay": "每晚 {{price}}",
    "plansTitle": "俱乐部会员",
    "plansNote": "会员按月付费，在您取消之前自动续订。您可以随时取消，会员资格保留到已付费月份结束。",
    "planNote": {
      "free": "在 Telegram 机器人中注册，无需付费，没有期限。",
      "plus": "在机器人中开通。如果您是通过合作房产中介来的，订阅免费赠送（通常为 {{days}} 天或更长，具体由各中介决定）。",
      "elite": "通过机器人聊天中的俱乐部客服开通。"
    },
    "servicesTitle": "服务",
    "servicesNote": "以下为基础价格。在您确认订单之前，机器人会显示包含您所选参数和会员折扣的准确价格。确认后价格不再变动。",
    "rows": {
      "cleaning": {
        "name": "公寓清洁",
        "note": "取决于清洁类型和房间数量"
      },
      "transferStandard": {
        "name": "兹瓦尔特诺茨机场接机，标准",
        "note": "最多 3 名乘客，举牌接机，等候 60 分钟"
      },
      "transferPremium": {
        "name": "兹瓦尔特诺茨机场接机，高级",
        "note": "商务车型，饮用水，SIM 卡"
      },
      "hotel": {
        "name": "落地头几天的酒店",
        "note": "Barev+ 会员价；非会员每晚 {{base}} 起"
      },
      "socialCard": {
        "name": "社会卡全程办理",
        "note": "护照翻译、公证、预约、陪同"
      },
      "consultation": {
        "name": "居留许可咨询",
        "note": "费用可抵扣陪同办理费"
      },
      "residence": {
        "name": "居留许可陪同办理",
        "note": "申请依据、材料、递交、到场办理。1 年期居留许可的国家规费 {{fee}} 另行向国家缴纳"
      }
    },
    "payTitle": "付款与取消",
    "payBody": "Barev+ 和 Elite 会员可在网站或应用中以欧元刷卡支付，每月自动续费，可随时关闭续费。付款由 Tribute 处理，会员费可在 14 天内申请退款。服务订单可在应用中在线支付（按汇率以欧元计）、或以现金和转账支付。服务开始前 24 小时以上可以免费取消或改期。详情请见使用条款和退款政策。"
  },
  "terms": {
    "title": "使用条款",
    "updated": "2026 年 10 月 22 日版本",
    "intro": "本条款规定 Barev Club 通过 barevclub.com 网站、Telegram 机器人和小程序提供服务的条件。下单或开通会员即表示您接受本条款。",
    "about": {
      "title": "我们是谁，做什么",
      "body": "Barev Club 是为搬到亚美尼亚或已在这里生活的人提供的服务：生活服务（清洁、机场接机、落地头几天的酒店）、证件办理协助（社会卡、居留许可）、学习课程以及俱乐部合作伙伴的折扣。\n服务提供方为个体经营者 Yuri Konstantinovich Zabudko（Ա/Ձ Զաբուդկո Յուրի Կոնստանտինի），亚美尼亚共和国，税号（ՀՎՀՀ）{{tin}}。联系方式：{{email}}，{{phone}}。\n订单由经过审核的服务人员完成——我们的员工或合作公司。对您而言，由 Barev Club 对结果负责。"
    },
    "acceptance": {
      "title": "接受条款",
      "body": "自您在网站或机器人中下单、开通会员或提交申请之时起，本条款即适用。使用本服务须年满 18 岁。\n如果您不同意本条款，请不要下单。"
    },
    "orders": {
      "title": "下单流程",
      "body": "• 您在机器人中选择服务或在网站上提交申请，并填写地址、日期、时间等信息。\n• 在确认之前，机器人会显示总价、折扣和取消条件。\n• 您确认订单且我们指派服务人员后，订单即被接受。您会收到此次及之后每个状态的通知。\n• 您通过机器人中的聊天与服务人员沟通。\n如果无法在您选择的时间完成订单，我们会提供其他时间，或免费取消订单。"
    },
    "prices": {
      "title": "价格",
      "body": "价格以亚美尼亚德拉姆标示在「价格」页面和机器人中。我们可能调整价格，但已确认订单的价格不会改变。\n除非明确说明，国家规费和税费（例如居留许可规费）不包含在服务价格中。我们会提前告知金额。"
    },
    "payment": {
      "title": "付款",
      "body": "Barev+ 和 Barev Elite 会员可在网站或应用中在线刷卡支付。会员每月从同一张卡自动续费；可随时在应用（“会员”）中或联系我们关闭续费，已付月份保持有效。服务订单可在应用中在线支付——金额按付款前显示的汇率从德拉姆换算为欧元。在线付款由支付服务 Tribute（tribute.tg）处理；银行卡信息在其页面上填写，我们不会接收或保存。\n服务（清洁、接机、证件办理等）不在线销售：可用现金或转账给服务人员，或转账至 Barev Club 账户支付，付款方式在订单中选择。\n如有需要，我们可以开具付款凭证。"
    },
    "cancel": {
      "title": "取消与改期",
      "body": "服务开始前 24 小时以上，您可以在机器人中或与客服聊天免费取消或改期。\n更晚取消将扣除部分费用。扣除比例在确认订单前显示在服务卡片上，默认为 30%。\n如果是我们取消订单或服务人员未到场，将全额退款。详情请见退款政策。"
    },
    "subscription": {
      "title": "Barev+ 和 Barev Elite 会员",
      "body": "• 会员可享受俱乐部服务折扣、合作伙伴礼品和聊天礼宾服务。各等级内容和价格见「价格」页面。\n• 会员按月付费，在您取消之前自动续订。我们会在续订前 3 天提醒您。\n• 折扣适用于会员有效期内下的订单。\n• 凭合作中介代码获得的免费期，每位客户仅限一次。\n• 您可以随时在机器人中或与客服聊天取消会员，会员资格保留到已付费期结束。"
    },
    "perks": {
      "title": "合作伙伴折扣与礼品",
      "body": "凭俱乐部卡享受的折扣和礼品由俱乐部合作伙伴提供——咖啡馆、餐厅和其他商家。每项优惠的条件见合作伙伴目录。\n合作伙伴对其商品和服务负责。合作伙伴的优惠可能变更或结束。"
    },
    "docs": {
      "title": "证件服务",
      "body": "我们协助您准备材料、翻译、预约并陪同您前往政府机构。是否签发证件或居留许可由政府机构决定，我们无法保证结果。\n您需保证提供给我们的文件和信息真实准确。如果因我们的失误被拒，我们将自费纠正。"
    },
    "client": {
      "title": "您的义务",
      "body": "• 提供正确信息：地址、联系方式、订单参数。\n• 在约定时间提供进入公寓的条件，并为服务人员提供安全的工作环境。\n• 尊重服务人员和客服。\n• 不将本服务用于违法目的。\n如果因您的原因服务人员无法开始工作（例如地址处无人），视为逾期取消。"
    },
    "quality": {
      "title": "质量与投诉",
      "body": "如果您对结果不满意，请在完成后 24 小时内在订单聊天中留言，可以的话附上照片。我们会免费返工，或退还部分或全部费用。\n如果服务人员损坏了您的财物，请在 24 小时内告知我们——我们会调查并赔偿经确认的损失。"
    },
    "liability": {
      "title": "责任",
      "body": "我们对订单的责任以订单金额为限，但经确认的财产损失以及法律不允许此类限制的情况除外。\n对于我们无法控制的情况造成的延误和取消，我们不承担责任：政府机构的决定、航班延误、自然灾害、Telegram 故障。"
    },
    "content": {
      "title": "网站内容",
      "body": "文字、设计、标志和 Barev Club 名称归服务所有者所有。未经许可不得复制。"
    },
    "changes": {
      "title": "条款变更",
      "body": "我们可能更新本条款。现行版本始终在本页面，版本日期标在开头。已确认的订单按原条款执行。会员的重大变更我们会提前在机器人中通知您。"
    },
    "law": {
      "title": "适用法律与争议",
      "body": "本条款适用亚美尼亚共和国法律。争议首先通过协商解决——请写信至 {{email}}，我们会在 3 个工作日内回复。如果无法达成一致，争议由亚美尼亚共和国法院审理。\n本条款不限制您依法享有的消费者权利。\n原文为俄语，译文仅为方便阅读。"
    }
  },
  "refund": {
    "title": "取消与退款",
    "updated": "2026 年 10 月 22 日版本",
    "intro": "Barev Club 在什么情况下、退还多少服务费和会员费，以及如何申请退款。",
    "cancelClient": {
      "title": "如果您取消",
      "body": "• 服务开始前 24 小时及以上——取消和改期免费，全额退款。\n• 不足 24 小时——扣除部分费用，其余退还。扣除比例在确认订单前显示在服务卡片上，默认为 30%。\n• 服务开始后，已完成部分的费用不予退还。"
    },
    "cancelUs": {
      "title": "如果我们取消",
      "body": "如果我们取消了订单、没有找到服务人员或服务人员未到场，由您选择：改到方便的时间，或全额退款。"
    },
    "quality": {
      "title": "如果您对结果不满意",
      "body": "请在完成后 24 小时内在订单聊天中留言，可以的话附上照片。我们会免费返工；如果无法返工，将根据问题情况退还部分或全部费用。"
    },
    "subscription": {
      "title": "Barev+ 和 Barev Elite 会员",
      "body": "• 任何一笔会员费，只要在扣款后 14 天内提出申请，均可全额退还。\n• 您可以随时取消——下一次将不再扣款，会员资格保留到已付费月份结束。\n• 免费期不收费，因此无需退款。"
    },
    "nonRefundable": {
      "title": "不予退还的费用",
      "body": "• 我们已代您缴纳的国家规费和税费。\n• 我们已为您的订单向第三方支付的费用：例如公证翻译，或按酒店规定处理的酒店预订。\n• 俱乐部合作伙伴的商品和服务——适用合作伙伴的规定。"
    },
    "howTo": {
      "title": "如何申请退款",
      "body": "在机器人聊天中或发送邮件至 {{email}}，注明订单号或会员编号以及原因。我们会在 3 个工作日内回复。\n如果你是在线付款的，款项将通过支付服务 Tribute 退回同一张卡，通常在我们确认后的几个工作日内到账。"
    },
    "timing": {
      "title": "退款时间与方式",
      "body": "退款在批准后 10 个工作日内按您的原付款方式退回。退回银行卡可能还需几天，取决于您的银行。如果您以现金付款，我们会按您的意愿通过转账或现金退还。\n退款问题：{{email}}，{{phone}}。"
    }
  }
}
